// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faMapMarkerAlt,
//   faArrowRight,
//   faVrCardboard,
//   faFileAlt,
//   faWalking,
//   faConciergeBell,
//   faTimes,
//   faExpand,
//   faCog,
//   faSpinner,
// } from "@fortawesome/free-solid-svg-icons";
// import { apiJson } from "../api/apiClient";
// import { apiUrl, imgUrl } from "../apiUrl";
// import "../styles/ProjectsLayout.css";
// const ApiUrl = apiUrl;
// const API_BASE = `${apiUrl}/api`;

// const ProjectsLayout = () => {
//   const navigate = useNavigate();
//   const { tenant } = useParams();

//   const withTenant = (path) => `/${tenant}${path}`;

//   const [projects, setProjects] = useState([]);
//   const [settings, setSettings] = useState({});
//   const [platformSettings, setPlatformSettings] = useState({});
//   const [hoveredId, setHoveredId] = useState(null);
//   const [loaded, setLoaded] = useState(false);
//   const [activeTab, setActiveTab] = useState({});
//   const [brochureModal, setBrochureModal] = useState(null);
//   const [amenityModal, setAmenityModal] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [isSetupComplete, setIsSetupComplete] = useState(false);
//   const [settingsLoaded, setSettingsLoaded] = useState(false);
//   const [projectsLoaded, setProjectsLoaded] = useState(false);

//   // ── Amenity modal handlers ─────────────────────────────
//   const openAmenityModal = (e, amenities, projectName, startIndex = 0) => {
//     e.stopPropagation();
//     setAmenityModal({ amenities, currentIndex: startIndex, projectName });
//   };
//   const closeAmenityModal = () => setAmenityModal(null);

//   const prevAmenity = (e) => {
//     if (e) e.stopPropagation();
//     setAmenityModal((prev) => ({
//       ...prev,
//       currentIndex:
//         prev.currentIndex === 0
//           ? prev.amenities.length - 1
//           : prev.currentIndex - 1,
//     }));
//   };

//   const nextAmenity = (e) => {
//     if (e) e.stopPropagation();
//     setAmenityModal((prev) => ({
//       ...prev,
//       currentIndex:
//         prev.currentIndex === prev.amenities.length - 1
//           ? 0
//           : prev.currentIndex + 1,
//     }));
//   };

//   // ── Brochure modal handlers ────────────────────────────
//   const openBrochure = (e, url, name) => {
//     e.stopPropagation();
//     setBrochureModal({ url, name });
//   };
//   const closeBrochure = () => setBrochureModal(null);

//   // ── Tab handler ────────────────────────────────────────
//   const handleTabChange = (projectId, tab, e) => {
//     e.stopPropagation();
//     setActiveTab((prev) => ({ ...prev, [projectId]: tab }));
//   };

//   // ── Body class ─────────────────────────────────────────
//   useEffect(() => {
//     document.body.classList.add("projects-page-active");
//     return () => document.body.classList.remove("projects-page-active");
//   }, []);

//   // ── Fetch settings ─────────────────────────────────────
//   useEffect(() => {
//     if (!tenant) return;

//     const fetchSettings = async () => {
//       try {
//         const data = await apiJson(tenant, "/settings");
//         setSettings(data);
//         setSettingsLoaded(true);
//       } catch (err) {
//         console.error("Error fetching settings:", err);
//         setSettingsLoaded(true);
//       }
//     };

//     fetchSettings();
//   }, [tenant]);

//   // ── Fetch Platform settings ─────────────────────────────────────
//   useEffect(() => {
//     const fetchPlatformSettings = async () => {
//       try {
//         const response = await fetch(`${API_BASE}/platform-settings`);

//         if (!response.ok) {
//           throw new Error(`HTTP ${response.status}`);
//         }

//         const platformData = await response.json();
//         setPlatformSettings(platformData);
//       } catch (err) {
//         console.error("Error fetching platform settings:", err);
//       }
//     };

//     fetchPlatformSettings();
//   }, []);

//   // ── Fetch projects ─────────────────────────────────────
//   useEffect(() => {
//     if (!tenant) return;

//     const fetchProjects = async () => {
//       try {
//         const data = await apiJson(tenant, "/all-projects");
//         setProjects(data);

//         const tabs = {};
//         data.forEach((p) => (tabs[p.id] = "overview"));
//         setActiveTab(tabs);
//         setProjectsLoaded(true);

//         setTimeout(() => setLoaded(true), 100);
//       } catch (err) {
//         console.error("Error fetching projects:", err);
//         setProjects([]);
//         setProjectsLoaded(true);
//       }
//     };

//     fetchProjects();
//   }, [tenant]);

//   // ── Check setup completion when both settings and projects are loaded ──
//   useEffect(() => {
//     // Only check when both settings and projects are loaded
//     if (!settingsLoaded || !projectsLoaded) {
//       return;
//     }

//     // Check if tenant has completed setup
//     const hasCompanyName = settings.company_name && settings.company_name.trim() !== "";
//     const hasLogo = settings.logo_dark_url && settings.logo_dark_url.trim() !== "";
//     const hasProjects = projects.length > 0;

//     const setupComplete = hasCompanyName && hasLogo && hasProjects;

//     setIsSetupComplete(setupComplete);
//     setIsLoading(false);
//   }, [settingsLoaded, projectsLoaded, settings, projects]);

//   // ── Keyboard nav: amenity modal ────────────────────────
//   useEffect(() => {
//     if (!amenityModal) return;
//     const handleKey = (e) => {
//       if (e.key === "ArrowLeft") prevAmenity(null);
//       if (e.key === "ArrowRight") nextAmenity(null);
//       if (e.key === "Escape") closeAmenityModal();
//     };
//     window.addEventListener("keydown", handleKey);
//     return () => window.removeEventListener("keydown", handleKey);
//   }, [amenityModal]);

//   // ── Keyboard nav: brochure modal ───────────────────────
//   useEffect(() => {
//     if (!brochureModal) return;
//     const handleKey = (e) => {
//       if (e.key === "Escape") closeBrochure();
//     };
//     window.addEventListener("keydown", handleKey);
//     return () => window.removeEventListener("keydown", handleKey);
//   }, [brochureModal]);

//   // ── Apply theme from settings ──────────────────────────
//   useEffect(() => {
//     if (!settings) return;
//     const root = document.documentElement;
//     if (settings.primary_color)
//       root.style.setProperty("--primary-color", settings.primary_color);
//     if (settings.primary_color_hover)
//       root.style.setProperty("--primary-hover", settings.primary_color_hover);
//     if (settings.accent_color)
//       root.style.setProperty("--accent-color", settings.accent_color);
//     if (settings.text_color_dark)
//       root.style.setProperty("--text-dark", settings.text_color_dark);
//     if (settings.text_color_muted)
//       root.style.setProperty("--text-muted", settings.text_color_muted);
//     if (settings.card_border_color)
//       root.style.setProperty("--card-border", settings.card_border_color);
//     if (settings.page_bg_color)
//       root.style.setProperty("--page-bg", settings.page_bg_color);
//     if (settings.card_bg_color)
//       root.style.setProperty("--card-bg", settings.card_bg_color);
//     if (settings.heading_font)
//       root.style.setProperty("--font-heading", settings.heading_font);
//     if (settings.body_font)
//       root.style.setProperty("--font-body", settings.body_font);
//     if (settings.google_fonts_url) {
//       let link = document.getElementById("dynamic-google-fonts");
//       if (!link) {
//         link = document.createElement("link");
//         link.id = "dynamic-google-fonts";
//         link.rel = "stylesheet";
//         document.head.appendChild(link);
//       }
//       link.href = settings.google_fonts_url;
//     }
//   }, [settings]);

//   // ── Loading state ──────────────────────────────────────
//   if (isLoading) {
//     return (
//       <main className="projects-page">
//         <div className="projects-loading">
//           <FontAwesomeIcon icon={faSpinner} spin size="3x" />
//           <p>Loading tenant setup...</p>
//         </div>
//       </main>
//     );
//   }

//   // ── Welcome / Setup Required State ────────────────────
//   if (!isSetupComplete) {
//     return (
//       <main className="projects-page">
//         <div className="projects-welcome-container">
//           <div className="projects-welcome">
//             <div className="welcome-logo">
//               {platformSettings.app_logo_dark_url ? (
//                 <img
//                   src={platformSettings.app_logo_dark_url}
//                   alt="Platform Logo"
//                   className="platform-logo"
//                 />
//               ) : (
//                 <div className="platform-logo-placeholder">
//                   <FontAwesomeIcon icon={faCog} size="4x" />
//                 </div>
//               )}
//             </div>

//             <h1 className="welcome-title">
//               Welcome to <span className="highlight">Your App</span>
//             </h1>

//             <p className="welcome-subtitle">
//               Your tenant setup is not yet complete. Please complete the
//               following steps to start showcasing your properties.
//             </p>

//             <div className="welcome-steps">
//               <div className="welcome-step">
//                 <div className="step-number">1</div>
//                 <div className="step-content">
//                   <h3>Add Company Information</h3>
//                   <p>Set up your company name, logo, and branding details</p>
//                 </div>
//               </div>

//               <div className="welcome-step">
//                 <div className="step-number">2</div>
//                 <div className="step-content">
//                   <h3>Configure Settings</h3>
//                   <p>Choose colors, fonts, and design preferences</p>
//                 </div>
//               </div>

//               <div className="welcome-step">
//                 <div className="step-number">3</div>
//                 <div className="step-content">
//                   <h3>Add Your Properties</h3>
//                   <p>
//                     Create your first project with details, images, and
//                     amenities
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="welcome-actions">
//               <button
//                 className="welcome-cta"
//                 onClick={() => {
//                   window.open(
//                     `${ApiUrl}/${tenant}/admin/login-form`,
//                     "_blank",
//                     "noopener,noreferrer",
//                   );
//                 }}
//               >
//                 Start Setup
//                 <FontAwesomeIcon icon={faArrowRight} className="cta-arrow" />
//               </button>
//             </div>
//           </div>
//         </div>
//       </main>
//     );
//   }

//   // ── Main Projects View (when setup is complete) ──────
//   return (
//     <main className="projects-page">
//       {/* ── Full-screen Split Header ─────────────────────── */}
//       <header className="projects-header">
//         {/* Left: Text */}
//         <div className="projects-header__left">
//           {settings.logo_dark_url && (
//             <div className="logo-img-div">
//               <img
//                 src={settings.logo_dark_url}
//                 alt={settings.company_name || "Logo"}
//                 className="projects-logo"
//               />
//             </div>
//           )}

//           <div className="projects-eyebrow-wrap">
//             <span className="projects-eyebrow__line" />
//             <span className="projects-eyebrow">
//               {settings.app_eyebrow || "Our Portfolio"}
//             </span>
//           </div>

//           <h1 className="projects-title">
//             {settings.app_tagline || "Exceptional"}
//             <em>{settings.app_tagline_italic || "Properties"}</em>
//           </h1>

//           <p className="projects-subtitle">
//             {settings.app_subtitle ||
//               "Discover handcrafted developments built for modern living"}
//           </p>

//           <div className="projects-header__scroll">
//             <span className="projects-header__scroll-line" />
//             Explore below
//           </div>
//         </div>

//         {/* Divider */}
//         <div className="projects-header__divider" />

//         {/* Right: Hero image — use first project's image if available */}
//         {projects.length > 0 && (
//           <div className="projects-header__right">
//             <img
//               src={projects[0].project_image_url}
//               alt={projects[0].project_name}
//               className="projects-header__hero-img"
//             />
//           </div>
//         )}
//       </header>

//       {/* ── Section label ───────────────────────────────── */}
//       <div className="projects-section-label">
//         <h2 className="projects-section-label__text">
//           All <em>Residences</em>
//         </h2>
//         {projects.length > 0 && (
//           <span className="projects-section-label__count">
//             {String(projects.length).padStart(2, "0")} Properties
//           </span>
//         )}
//       </div>

//       {/* ── Projects: Full-width split rows ─────────────── */}
//       <div className={`projects-grid ${loaded ? "is-loaded" : ""}`}>
//         {projects.map((project, index) => (
//           <article
//             key={project.id}
//             className={`project-card ${hoveredId === project.id ? "is-hovered" : ""}`}
//             style={{ animationDelay: `${index * 120}ms` }}
//             onMouseEnter={() => setHoveredId(project.id)}
//             onMouseLeave={() => setHoveredId(null)}
//           >
//             {/* ── Image Panel ──────────────────────────── */}
//             <div
//               className="project-card__image-panel"
//               onClick={() =>
//                 !project.is_upcoming &&
//                 navigate(withTenant(`/location/${project.id}`))
//               }
//               style={{ cursor: project.is_upcoming ? "default" : "pointer" }}
//             >
//               <img
//                 src={project.project_image_url}
//                 alt={project.project_name}
//                 className="project-card__image"
//               />
//               <div className="project-card__image-overlay" />
//               {project.is_upcoming && (
//                 <div className="project-card__upcoming-badge">
//                   <span className="upcoming-badge__pulse" />
//                   <span className="upcoming-badge__text">Coming Soon</span>
//                 </div>
//               )}

//               {/* Logo overlaid on image */}
//               <div className="project-card__logo-wrap">
//                 <img
//                   src={project.logo_url}
//                   alt={`${project.project_name} logo`}
//                   className="project-card__logo"
//                 />
//               </div>
//             </div>

//             {/* ── Content Panel ────────────────────────── */}
//             <div
//               className="project-card__panel"
//               data-index={String(index + 1).padStart(2, "0")}
//             >
//               {/* Tabs */}
//               <div
//                 className="project-card__tabs"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <button
//                   className={`tab-btn ${activeTab[project.id] === "overview" ? "active" : ""}`}
//                   onClick={(e) => handleTabChange(project.id, "overview", e)}
//                 >
//                   Overview
//                 </button>

//                 {project.amenities_count > 0 && (
//                   <button
//                     className={`tab-btn ${activeTab[project.id] === "amenities" ? "active" : ""}`}
//                     onClick={(e) => handleTabChange(project.id, "amenities", e)}
//                   >
//                     <FontAwesomeIcon
//                       icon={faConciergeBell}
//                       className="tab-icon"
//                     />
//                     Amenities
//                   </button>
//                 )}

//                 {project.walkthroughs?.length > 0 && (
//                   <button
//                     className={`tab-btn ${activeTab[project.id] === "walkthrough" ? "active" : ""}`}
//                     onClick={(e) =>
//                       handleTabChange(project.id, "walkthrough", e)
//                     }
//                   >
//                     <FontAwesomeIcon icon={faWalking} className="tab-icon" />
//                     Walk
//                   </button>
//                 )}

//                 {project.virtual_tours?.length > 0 && (
//                   <button
//                     className={`tab-btn ${activeTab[project.id] === "tour" ? "active" : ""}`}
//                     onClick={(e) => handleTabChange(project.id, "tour", e)}
//                   >
//                     <FontAwesomeIcon
//                       icon={faVrCardboard}
//                       className="tab-icon"
//                     />
//                     360°
//                   </button>
//                 )}
//               </div>

//               {/* Tab Content */}
//               <div className="project-card__content">
//                 {/* Overview */}
//                 {activeTab[project.id] === "overview" && (
//                   <div className="tab-content">
//                     <div className="project-card__location">
//                       <FontAwesomeIcon
//                         icon={faMapMarkerAlt}
//                         className="pin-icon"
//                       />
//                       <span>{project.location}</span>
//                     </div>

//                     <h3 className="project-card__name">
//                       {project.project_name}
//                     </h3>

//                     {project.description && (
//                       <p className="project-card__description">
//                         {project.description}
//                       </p>
//                     )}

//                     <div className="project-card__actions">
//                       {project.is_upcoming ? (
//                         <div className="project-card__upcoming-info">
//                           <span className="upcoming-info__dot" />
//                           <span className="upcoming-info__text">
//                             Booking opening soon
//                           </span>
//                         </div>
//                       ) : (
//                         <button
//                           className="project-card__cta"
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             navigate(withTenant(`/location/${project.id}`));
//                           }}
//                         >
//                           Choose Your Units
//                           <FontAwesomeIcon
//                             icon={faArrowRight}
//                             className="cta-arrow"
//                           />
//                         </button>
//                       )}
//                       {!project.is_upcoming && (
//                         <div className="project-card__icon-actions">
//                           {project.master_plan_id && (
//                             <button
//                               className="project-card__icon-btn"
//                               title="360° Panorama"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 navigate(
//                                   withTenant(
//                                     `/apartment-view/${project.master_plan_id}`,
//                                   ),
//                                 );
//                               }}
//                             >
//                               <FontAwesomeIcon icon={faVrCardboard} />
//                               <span>Panorama</span>
//                             </button>
//                           )}

//                           {project.walkthroughs?.length > 0 && (
//                             <button
//                               className="project-card__icon-btn"
//                               title="Walkthrough"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 window.open(
//                                   project.walkthroughs[0].walkthrough_url,
//                                   "_blank",
//                                 );
//                               }}
//                             >
//                               <FontAwesomeIcon icon={faWalking} />
//                               <span>Walkthrough</span>
//                             </button>
//                           )}

//                           {project.virtual_tours?.length > 0 && (
//                             <button
//                               className="project-card__icon-btn"
//                               title="Virtual Tour"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 window.open(
//                                   project.virtual_tours[0].tour_url,
//                                   "_blank",
//                                 );
//                               }}
//                             >
//                               <FontAwesomeIcon icon={faVrCardboard} />
//                               <span>360° Tour</span>
//                             </button>
//                           )}

//                           {project.brochures?.length > 0 && (
//                             <button
//                               className="project-card__icon-btn"
//                               title="Brochure"
//                               onClick={(e) =>
//                                 openBrochure(
//                                   e,
//                                   project.brochures[0].brochure_url,
//                                   project.brochures[0].title ||
//                                     project.project_name,
//                                 )
//                               }
//                             >
//                               <FontAwesomeIcon icon={faFileAlt} />
//                               <span>Brochure</span>
//                             </button>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 )}

//                 {/* Amenities */}
//                 {activeTab[project.id] === "amenities" && (
//                   <div className="tab-content amenities-tab">
//                     <div className="amenities-grid">
//                       {project.amenities?.map((amenity, i) => (
//                         <div
//                           key={i}
//                           className="amenity-item"
//                           onClick={(e) =>
//                             openAmenityModal(
//                               e,
//                               project.amenities,
//                               project.project_name,
//                               i,
//                             )
//                           }
//                           title={amenity.amenity_name}
//                         >
//                           {amenity.amenity_icon ? (
//                             <img
//                               src={amenity.amenity_icon_url}
//                               alt={amenity.amenity_name}
//                               className="amenity-icon"
//                             />
//                           ) : (
//                             <FontAwesomeIcon
//                               icon={faConciergeBell}
//                               className="amenity-icon-fa"
//                             />
//                           )}
//                           <span className="amenity-name">
//                             {amenity.amenity_name}
//                           </span>
//                           {amenity.amenity_image && (
//                             <span className="amenity-expand-hint">
//                               <FontAwesomeIcon icon={faExpand} />
//                             </span>
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                     <button
//                       className="project-card__cta mt-3"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         navigate(withTenant(`/location/${project.id}`));
//                       }}
//                     >
//                       Explore Project
//                       <FontAwesomeIcon
//                         icon={faArrowRight}
//                         className="cta-arrow"
//                       />
//                     </button>
//                   </div>
//                 )}

//                 {/* Walkthrough */}
//                 {activeTab[project.id] === "walkthrough" && (
//                   <div className="tab-content tour-tab">
//                     <h4 className="tab-heading">Walkthrough</h4>
//                     {project.walkthroughs.map((wt, i) => (
//                       <div
//                         key={i}
//                         className="tour-preview"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           window.open(wt.walkthrough_url, "_blank");
//                         }}
//                       >
//                         <FontAwesomeIcon
//                           icon={faWalking}
//                           className="tour-play-icon"
//                         />
//                         <span>{wt.title || `Walkthrough ${i + 1}`}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* 360° Tour */}
//                 {activeTab[project.id] === "tour" && (
//                   <div className="tab-content tour-tab">
//                     <h4 className="tab-heading">360° Virtual Tour</h4>
//                     {project.virtual_tours.map((vt, i) => (
//                       <div
//                         key={i}
//                         className="tour-preview"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           window.open(vt.tour_url, "_blank");
//                         }}
//                       >
//                         <FontAwesomeIcon
//                           icon={faVrCardboard}
//                           className="tour-play-icon"
//                         />
//                         <span>{vt.title || `360° Tour ${i + 1}`}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </article>
//         ))}
//       </div>

//       {/* ── Amenity Modal ───────────────────────────────── */}
//       {amenityModal && (
//         <div className="amenity-modal-overlay" onClick={closeAmenityModal}>
//           <div className="amenity-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="amenity-modal__header">
//               <h5>{amenityModal.projectName} — Amenities</h5>
//               <button className="modal-close-btn" onClick={closeAmenityModal}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>

//             <div className="amenity-modal__stage">
//               {amenityModal.amenities.length > 1 && (
//                 <button
//                   className="amenity-modal__nav amenity-modal__nav--prev"
//                   onClick={prevAmenity}
//                 >
//                   <FontAwesomeIcon
//                     icon={faArrowRight}
//                     style={{ transform: "rotate(180deg)" }}
//                   />
//                 </button>
//               )}

//               <div className="amenity-modal__image-wrap">
//                 {amenityModal.amenities[amenityModal.currentIndex]
//                   ?.amenity_image ? (
//                   <img
//                     key={amenityModal.currentIndex}
//                     src={
//                       amenityModal.amenities[amenityModal.currentIndex]
//                         .amenity_image_url
//                     }
//                     alt={
//                       amenityModal.amenities[amenityModal.currentIndex]
//                         .amenity_name
//                     }
//                     className="amenity-modal__image"
//                   />
//                 ) : (
//                   <div className="amenity-modal__no-image">
//                     <FontAwesomeIcon icon={faConciergeBell} />
//                     <span>No image available</span>
//                   </div>
//                 )}

//                 <div className="amenity-modal__name-overlay">
//                   {amenityModal.amenities[amenityModal.currentIndex]
//                     ?.amenity_icon && (
//                     <img
//                       src={
//                         amenityModal.amenities[amenityModal.currentIndex]
//                           .amenity_icon_url
//                       }
//                       alt="icon"
//                       className="amenity-modal__icon-badge"
//                     />
//                   )}
//                   <span className="amenity-modal__name">
//                     {
//                       amenityModal.amenities[amenityModal.currentIndex]
//                         ?.amenity_name
//                     }
//                   </span>
//                   <span className="amenity-modal__counter">
//                     {amenityModal.currentIndex + 1} /{" "}
//                     {amenityModal.amenities.length}
//                   </span>
//                 </div>
//               </div>

//               {amenityModal.amenities.length > 1 && (
//                 <button
//                   className="amenity-modal__nav amenity-modal__nav--next"
//                   onClick={nextAmenity}
//                 >
//                   <FontAwesomeIcon icon={faArrowRight} />
//                 </button>
//               )}
//             </div>

//             {amenityModal.amenities.length > 1 && (
//               <div className="amenity-modal__thumbs">
//                 {amenityModal.amenities.map((amenity, i) => (
//                   <div
//                     key={i}
//                     className={`amenity-thumb ${i === amenityModal.currentIndex ? "active" : ""}`}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setAmenityModal((prev) => ({
//                         ...prev,
//                         currentIndex: i,
//                       }));
//                     }}
//                   >
//                     {amenity.amenity_icon ? (
//                       <img
//                         src={amenity.amenity_icon_url}
//                         alt={amenity.amenity_name}
//                         className="amenity-thumb__icon"
//                       />
//                     ) : (
//                       <FontAwesomeIcon
//                         icon={faConciergeBell}
//                         className="amenity-thumb__fa"
//                       />
//                     )}
//                     <span className="amenity-thumb__name">
//                       {amenity.amenity_name}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* ── Brochure Modal ──────────────────────────────── */}
//       {brochureModal && (
//         <div className="brochure-modal-overlay" onClick={closeBrochure}>
//           <div className="brochure-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="brochure-modal__header">
//               <h5>{brochureModal.name}</h5>
//               <button className="modal-close-btn" onClick={closeBrochure}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>
//             <div className="brochure-modal__body">
//               <iframe
//                 src={brochureModal.url}
//                 title="Brochure"
//                 width="100%"
//                 height="100%"
//                 style={{ border: "none" }}
//               />
//             </div>
//             <div className="brochure-modal__footer">
//               <a
//                 href={brochureModal.url}
//                 download
//                 className="project-card__cta"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <FontAwesomeIcon icon={faFileAlt} />
//                 Download PDF
//               </a>
//             </div>
//           </div>
//         </div>
//       )}
//     </main>
//   );
// };

// export default ProjectsLayout;

// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faMapMarkerAlt,
//   faArrowRight,
//   faVrCardboard,
//   faFileAlt,
//   faWalking,
//   faConciergeBell,
//   faTimes,
//   faExpand,
//   faCog,
//   faSpinner,
//   faBuilding,
// } from "@fortawesome/free-solid-svg-icons";
// import { apiJson } from "../api/apiClient";
// import { apiUrl, imgUrl } from "../apiUrl";
// import "../styles/ProjectsLayout.css";
// const ApiUrl = apiUrl;
// const API_BASE = `${apiUrl}/api`;

// // Where the "Register" button on the no-tenant screen sends people.
// // Set REACT_APP_LANDING_URL in your .env.
// const LANDING_URL = process.env.REACT_APP_LANDING_URL || "#";

// const ProjectsLayout = () => {
//   const navigate = useNavigate();
//   const { tenant } = useParams();

//   const withTenant = (path) => `/${tenant}${path}`;

//   const [projects, setProjects] = useState([]);
//   const [settings, setSettings] = useState({});
//   const [platformSettings, setPlatformSettings] = useState({});
//   const [hoveredId, setHoveredId] = useState(null);
//   const [loaded, setLoaded] = useState(false);
//   const [activeTab, setActiveTab] = useState({});
//   const [brochureModal, setBrochureModal] = useState(null);
//   const [amenityModal, setAmenityModal] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [isSetupComplete, setIsSetupComplete] = useState(false);
//   const [settingsLoaded, setSettingsLoaded] = useState(false);
//   const [projectsLoaded, setProjectsLoaded] = useState(false);

//   // Fetch failures (bad slug, tenant deleted, server down) are tracked
//   // separately from "setup incomplete" — those are different messages.
//   const [settingsError, setSettingsError] = useState(null);
//   const [projectsError, setProjectsError] = useState(null);

//   // ── Amenity modal handlers ─────────────────────────────
//   const openAmenityModal = (e, amenities, projectName, startIndex = 0) => {
//     e.stopPropagation();
//     setAmenityModal({ amenities, currentIndex: startIndex, projectName });
//   };
//   const closeAmenityModal = () => setAmenityModal(null);

//   const prevAmenity = (e) => {
//     if (e) e.stopPropagation();
//     setAmenityModal((prev) => ({
//       ...prev,
//       currentIndex:
//         prev.currentIndex === 0
//           ? prev.amenities.length - 1
//           : prev.currentIndex - 1,
//     }));
//   };

//   const nextAmenity = (e) => {
//     if (e) e.stopPropagation();
//     setAmenityModal((prev) => ({
//       ...prev,
//       currentIndex:
//         prev.currentIndex === prev.amenities.length - 1
//           ? 0
//           : prev.currentIndex + 1,
//     }));
//   };

//   // ── Brochure modal handlers ────────────────────────────
//   const openBrochure = (e, url, name) => {
//     e.stopPropagation();
//     setBrochureModal({ url, name });
//   };
//   const closeBrochure = () => setBrochureModal(null);

//   // ── Tab handler ────────────────────────────────────────
//   const handleTabChange = (projectId, tab, e) => {
//     e.stopPropagation();
//     setActiveTab((prev) => ({ ...prev, [projectId]: tab }));
//   };

//   // ── Body class ─────────────────────────────────────────
//   useEffect(() => {
//     document.body.classList.add("projects-page-active");
//     return () => document.body.classList.remove("projects-page-active");
//   }, []);

//   // ── Fetch settings ─────────────────────────────────────
//   useEffect(() => {
//     if (!tenant) return;

//     const fetchSettings = async () => {
//       try {
//         const data = await apiJson(tenant, "/settings");
//         setSettings(data);
//         setSettingsLoaded(true);
//       } catch (err) {
//         console.error("Error fetching settings:", err);
//         setSettingsError(err.message || "Failed to load settings.");
//         setSettingsLoaded(true);
//       }
//     };

//     fetchSettings();
//   }, [tenant]);

//   // ── Fetch Platform settings ─────────────────────────────────────
//   useEffect(() => {
//     const fetchPlatformSettings = async () => {
//       try {
//         const response = await fetch(`${API_BASE}/platform-settings`);

//         if (!response.ok) {
//           throw new Error(`HTTP ${response.status}`);
//         }

//         const platformData = await response.json();
//         setPlatformSettings(platformData);
//       } catch (err) {
//         console.error("Error fetching platform settings:", err);
//       }
//     };

//     fetchPlatformSettings();
//   }, []);

//   // ── Fetch projects ─────────────────────────────────────
//   useEffect(() => {
//     if (!tenant) return;

//     const fetchProjects = async () => {
//       try {
//         const data = await apiJson(tenant, "/all-projects");
//         setProjects(data);

//         const tabs = {};
//         data.forEach((p) => (tabs[p.id] = "overview"));
//         setActiveTab(tabs);
//         setProjectsLoaded(true);

//         setTimeout(() => setLoaded(true), 100);
//       } catch (err) {
//         console.error("Error fetching projects:", err);
//         setProjects([]);
//         setProjectsError(err.message || "Failed to load projects.");
//         setProjectsLoaded(true);
//       }
//     };

//     fetchProjects();
//   }, [tenant]);

//   // ── Check setup completion when both settings and projects are loaded ──
//   useEffect(() => {
//     // Only check when both settings and projects are loaded
//     if (!settingsLoaded || !projectsLoaded) {
//       return;
//     }

//     // Check if tenant has completed setup
//     const hasCompanyName = settings.company_name && settings.company_name.trim() !== "";
//     const hasLogo = settings.logo_dark_url && settings.logo_dark_url.trim() !== "";
//     const hasProjects = projects.length > 0;

//     const setupComplete = hasCompanyName && hasLogo && hasProjects;

//     setIsSetupComplete(setupComplete);
//     setIsLoading(false);
//   }, [settingsLoaded, projectsLoaded, settings, projects]);

//   // ── Keyboard nav: amenity modal ────────────────────────
//   useEffect(() => {
//     if (!amenityModal) return;
//     const handleKey = (e) => {
//       if (e.key === "ArrowLeft") prevAmenity(null);
//       if (e.key === "ArrowRight") nextAmenity(null);
//       if (e.key === "Escape") closeAmenityModal();
//     };
//     window.addEventListener("keydown", handleKey);
//     return () => window.removeEventListener("keydown", handleKey);
//   }, [amenityModal]);

//   // ── Keyboard nav: brochure modal ───────────────────────
//   useEffect(() => {
//     if (!brochureModal) return;
//     const handleKey = (e) => {
//       if (e.key === "Escape") closeBrochure();
//     };
//     window.addEventListener("keydown", handleKey);
//     return () => window.removeEventListener("keydown", handleKey);
//   }, [brochureModal]);

//   // ── Apply theme from settings ──────────────────────────
//   useEffect(() => {
//     if (!settings) return;
//     const root = document.documentElement;
//     if (settings.primary_color)
//       root.style.setProperty("--primary-color", settings.primary_color);
//     if (settings.primary_color_hover)
//       root.style.setProperty("--primary-hover", settings.primary_color_hover);
//     if (settings.accent_color)
//       root.style.setProperty("--accent-color", settings.accent_color);
//     if (settings.text_color_dark)
//       root.style.setProperty("--text-dark", settings.text_color_dark);
//     if (settings.text_color_muted)
//       root.style.setProperty("--text-muted", settings.text_color_muted);
//     if (settings.card_border_color)
//       root.style.setProperty("--card-border", settings.card_border_color);
//     if (settings.page_bg_color)
//       root.style.setProperty("--page-bg", settings.page_bg_color);
//     if (settings.card_bg_color)
//       root.style.setProperty("--card-bg", settings.card_bg_color);
//     if (settings.heading_font)
//       root.style.setProperty("--font-heading", settings.heading_font);
//     if (settings.body_font)
//       root.style.setProperty("--font-body", settings.body_font);
//     if (settings.google_fonts_url) {
//       let link = document.getElementById("dynamic-google-fonts");
//       if (!link) {
//         link = document.createElement("link");
//         link.id = "dynamic-google-fonts";
//         link.rel = "stylesheet";
//         document.head.appendChild(link);
//       }
//       link.href = settings.google_fonts_url;
//     }
//   }, [settings]);

//   // ── No tenant in the URL at all ─────────────────────────
//   // Someone hit the bare domain instead of the link from their welcome
//   // email. Checked before everything else — no point loading anything
//   // if there's no tenant to load it for.
//   if (!tenant) {
//     return (
//       <main className="projects-page projects-page--no-tenant">
//         <div
//           style={{
//             minHeight: "100vh",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             textAlign: "center",
//             padding: "40px 20px",
//           }}
//         >
//           <FontAwesomeIcon
//             icon={faBuilding}
//             style={{ fontSize: 48, marginBottom: 24, opacity: 0.4 }}
//           />
//           <h1 style={{ marginBottom: 12 }}>No site selected</h1>
//           <p style={{ maxWidth: 440, marginBottom: 28, color: "#6c757d" }}>
//             This link doesn't point to a registered account. If you've
//             already signed up, check the welcome email we sent you when you
//             registered for your site's direct link. Otherwise, register to
//             get your own site set up.
//           </p>
//           <a
//             href={LANDING_URL}
//             className="project-card__cta"
//             style={{ display: "inline-flex", alignItems: "center", gap: 8, alignSelf: "center" }}
//           >
//             Register / Contact us
//             <FontAwesomeIcon icon={faArrowRight} className="cta-arrow" />
//           </a>
//         </div>
//       </main>
//     );
//   }

//   // ── Loading state ──────────────────────────────────────
//   if (isLoading) {
//     return (
//       <main className="projects-page">
//         <div className="projects-loading">
//           <FontAwesomeIcon icon={faSpinner} spin size="3x" />
//           <p>Loading tenant setup...</p>
//         </div>
//       </main>
//     );
//   }

//   // ── Couldn't reach the server / bad tenant slug ────────
//   // Distinct from "setup incomplete" — this is a real fetch failure,
//   // not a tenant who simply hasn't finished onboarding yet.
//   if (settingsError && projectsError) {
//     const isTenantNotFound =
//       settingsError.toLowerCase().includes("tenant") ||
//       projectsError.toLowerCase().includes("tenant");

//     return (
//       <main className="projects-page">
//         <div
//           style={{
//             minHeight: "100vh",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             textAlign: "center",
//             padding: "40px 20px",
//           }}
//         >
//           <FontAwesomeIcon
//             icon={faBuilding}
//             style={{ fontSize: 48, marginBottom: 24, opacity: 0.4 }}
//           />
//           <h1 style={{ marginBottom: 12 }}>We couldn't load this site</h1>
//           <p style={{ maxWidth: 440, color: "#6c757d" }}>
//             {isTenantNotFound
//               ? "This link doesn't match a registered account. Please check the URL, or contact us if you believe this is a mistake."
//               : "Something went wrong on our end. Please try again in a moment."}
//           </p>
//         </div>
//       </main>
//     );
//   }

//   // ── Welcome / Setup Required State ────────────────────
//   if (!isSetupComplete) {
//     return (
//       <main className="projects-page">
//         <div className="projects-welcome-container">
//           <div className="projects-welcome">
//             <div className="welcome-logo">
//               {platformSettings.app_logo_dark_url ? (
//                 <img
//                   src={platformSettings.app_logo_dark_url}
//                   alt="Platform Logo"
//                   className="platform-logo"
//                 />
//               ) : (
//                 <div className="platform-logo-placeholder">
//                   <FontAwesomeIcon icon={faCog} size="4x" />
//                 </div>
//               )}
//             </div>

//             <h1 className="welcome-title">
//               Welcome to <span className="highlight">Your App</span>
//             </h1>

//             <p className="welcome-subtitle">
//               Your tenant setup is not yet complete. Please complete the
//               following steps to start showcasing your properties.
//             </p>

//             <div className="welcome-steps">
//               <div className="welcome-step">
//                 <div className="step-number">1</div>
//                 <div className="step-content">
//                   <h3>Add Company Information</h3>
//                   <p>Set up your company name, logo, and branding details</p>
//                 </div>
//               </div>

//               <div className="welcome-step">
//                 <div className="step-number">2</div>
//                 <div className="step-content">
//                   <h3>Configure Settings</h3>
//                   <p>Choose colors, fonts, and design preferences</p>
//                 </div>
//               </div>

//               <div className="welcome-step">
//                 <div className="step-number">3</div>
//                 <div className="step-content">
//                   <h3>Add Your Properties</h3>
//                   <p>
//                     Create your first project with details, images, and
//                     amenities
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="welcome-actions">
//               <button
//                 className="welcome-cta"
//                 onClick={() => {
//                   window.open(
//                     `${ApiUrl}/${tenant}/admin/login-form`,
//                     "_blank",
//                     "noopener,noreferrer",
//                   );
//                 }}
//               >
//                 Start Setup
//                 <FontAwesomeIcon icon={faArrowRight} className="cta-arrow" />
//               </button>
//             </div>
//           </div>
//         </div>
//       </main>
//     );
//   }

//   // ── Main Projects View (when setup is complete) ──────
//   return (
//     <main className="projects-page">
//       {/* ── Full-screen Split Header ─────────────────────── */}
//       <header className="projects-header">
//         {/* Left: Text */}
//         <div className="projects-header__left">
//           {settings.logo_dark_url && (
//             <div className="logo-img-div">
//               <img
//                 src={settings.logo_dark_url}
//                 alt={settings.company_name || "Logo"}
//                 className="projects-logo"
//               />
//             </div>
//           )}

//           <div className="projects-eyebrow-wrap">
//             <span className="projects-eyebrow__line" />
//             <span className="projects-eyebrow">
//               {settings.app_eyebrow || "Our Portfolio"}
//             </span>
//           </div>

//           <h1 className="projects-title">
//             {settings.app_tagline || "Exceptional"}
//             <em>{settings.app_tagline_italic || "Properties"}</em>
//           </h1>

//           <p className="projects-subtitle">
//             {settings.app_subtitle ||
//               "Discover handcrafted developments built for modern living"}
//           </p>

//           <div className="projects-header__scroll">
//             <span className="projects-header__scroll-line" />
//             Explore below
//           </div>
//         </div>

//         {/* Divider */}
//         <div className="projects-header__divider" />

//         {/* Right: Hero image — use first project's image if available */}
//         {projects.length > 0 && (
//           <div className="projects-header__right">
//             <img
//               src={projects[0].project_image_url}
//               alt={projects[0].project_name}
//               className="projects-header__hero-img"
//             />
//           </div>
//         )}
//       </header>

//       {/* ── Section label ───────────────────────────────── */}
//       <div className="projects-section-label">
//         <h2 className="projects-section-label__text">
//           All <em>Residences</em>
//         </h2>
//         {projects.length > 0 && (
//           <span className="projects-section-label__count">
//             {String(projects.length).padStart(2, "0")} Properties
//           </span>
//         )}
//       </div>

//       {/* ── Projects: Full-width split rows ─────────────── */}
//       <div className={`projects-grid ${loaded ? "is-loaded" : ""}`}>
//         {projects.map((project, index) => (
//           <article
//             key={project.id}
//             className={`project-card ${hoveredId === project.id ? "is-hovered" : ""}`}
//             style={{ animationDelay: `${index * 120}ms` }}
//             onMouseEnter={() => setHoveredId(project.id)}
//             onMouseLeave={() => setHoveredId(null)}
//           >
//             {/* ── Image Panel ──────────────────────────── */}
//             <div
//               className="project-card__image-panel"
//               onClick={() =>
//                 !project.is_upcoming &&
//                 navigate(withTenant(`/location/${project.id}`))
//               }
//               style={{ cursor: project.is_upcoming ? "default" : "pointer" }}
//             >
//               <img
//                 src={project.project_image_url}
//                 alt={project.project_name}
//                 className="project-card__image"
//               />
//               <div className="project-card__image-overlay" />
//               {project.is_upcoming && (
//                 <div className="project-card__upcoming-badge">
//                   <span className="upcoming-badge__pulse" />
//                   <span className="upcoming-badge__text">Coming Soon</span>
//                 </div>
//               )}

//               {/* Logo overlaid on image */}
//               <div className="project-card__logo-wrap">
//                 <img
//                   src={project.logo_url}
//                   alt={`${project.project_name} logo`}
//                   className="project-card__logo"
//                 />
//               </div>
//             </div>

//             {/* ── Content Panel ────────────────────────── */}
//             <div
//               className="project-card__panel"
//               data-index={String(index + 1).padStart(2, "0")}
//             >
//               {/* Tabs */}
//               <div
//                 className="project-card__tabs"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <button
//                   className={`tab-btn ${activeTab[project.id] === "overview" ? "active" : ""}`}
//                   onClick={(e) => handleTabChange(project.id, "overview", e)}
//                 >
//                   Overview
//                 </button>

//                 {project.amenities_count > 0 && (
//                   <button
//                     className={`tab-btn ${activeTab[project.id] === "amenities" ? "active" : ""}`}
//                     onClick={(e) => handleTabChange(project.id, "amenities", e)}
//                   >
//                     <FontAwesomeIcon
//                       icon={faConciergeBell}
//                       className="tab-icon"
//                     />
//                     Amenities
//                   </button>
//                 )}

//                 {project.walkthroughs?.length > 0 && (
//                   <button
//                     className={`tab-btn ${activeTab[project.id] === "walkthrough" ? "active" : ""}`}
//                     onClick={(e) =>
//                       handleTabChange(project.id, "walkthrough", e)
//                     }
//                   >
//                     <FontAwesomeIcon icon={faWalking} className="tab-icon" />
//                     Walk
//                   </button>
//                 )}

//                 {project.virtual_tours?.length > 0 && (
//                   <button
//                     className={`tab-btn ${activeTab[project.id] === "tour" ? "active" : ""}`}
//                     onClick={(e) => handleTabChange(project.id, "tour", e)}
//                   >
//                     <FontAwesomeIcon
//                       icon={faVrCardboard}
//                       className="tab-icon"
//                     />
//                     360°
//                   </button>
//                 )}
//               </div>

//               {/* Tab Content */}
//               <div className="project-card__content">
//                 {/* Overview */}
//                 {activeTab[project.id] === "overview" && (
//                   <div className="tab-content">
//                     <div className="project-card__location">
//                       <FontAwesomeIcon
//                         icon={faMapMarkerAlt}
//                         className="pin-icon"
//                       />
//                       <span>{project.location}</span>
//                     </div>

//                     <h3 className="project-card__name">
//                       {project.project_name}
//                     </h3>

//                     {project.description && (
//                       <p className="project-card__description">
//                         {project.description}
//                       </p>
//                     )}

//                     <div className="project-card__actions">
//                       {project.is_upcoming ? (
//                         <div className="project-card__upcoming-info">
//                           <span className="upcoming-info__dot" />
//                           <span className="upcoming-info__text">
//                             Booking opening soon
//                           </span>
//                         </div>
//                       ) : (
//                         <button
//                           className="project-card__cta"
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             navigate(withTenant(`/location/${project.id}`));
//                           }}
//                         >
//                           Choose Your Units
//                           <FontAwesomeIcon
//                             icon={faArrowRight}
//                             className="cta-arrow"
//                           />
//                         </button>
//                       )}
//                       {!project.is_upcoming && (
//                         <div className="project-card__icon-actions">
//                           {project.master_plan_id && (
//                             <button
//                               className="project-card__icon-btn"
//                               title="360° Panorama"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 navigate(
//                                   withTenant(
//                                     `/apartment-view/${project.master_plan_id}`,
//                                   ),
//                                 );
//                               }}
//                             >
//                               <FontAwesomeIcon icon={faVrCardboard} />
//                               <span>Panorama</span>
//                             </button>
//                           )}

//                           {project.walkthroughs?.length > 0 && (
//                             <button
//                               className="project-card__icon-btn"
//                               title="Walkthrough"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 window.open(
//                                   project.walkthroughs[0].walkthrough_url,
//                                   "_blank",
//                                 );
//                               }}
//                             >
//                               <FontAwesomeIcon icon={faWalking} />
//                               <span>Walkthrough</span>
//                             </button>
//                           )}

//                           {project.virtual_tours?.length > 0 && (
//                             <button
//                               className="project-card__icon-btn"
//                               title="Virtual Tour"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 window.open(
//                                   project.virtual_tours[0].tour_url,
//                                   "_blank",
//                                 );
//                               }}
//                             >
//                               <FontAwesomeIcon icon={faVrCardboard} />
//                               <span>360° Tour</span>
//                             </button>
//                           )}

//                           {project.brochures?.length > 0 && (
//                             <button
//                               className="project-card__icon-btn"
//                               title="Brochure"
//                               onClick={(e) =>
//                                 openBrochure(
//                                   e,
//                                   project.brochures[0].brochure_url,
//                                   project.brochures[0].title ||
//                                     project.project_name,
//                                 )
//                               }
//                             >
//                               <FontAwesomeIcon icon={faFileAlt} />
//                               <span>Brochure</span>
//                             </button>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 )}

//                 {/* Amenities */}
//                 {activeTab[project.id] === "amenities" && (
//                   <div className="tab-content amenities-tab">
//                     <div className="amenities-grid">
//                       {project.amenities?.map((amenity, i) => (
//                         <div
//                           key={i}
//                           className="amenity-item"
//                           onClick={(e) =>
//                             openAmenityModal(
//                               e,
//                               project.amenities,
//                               project.project_name,
//                               i,
//                             )
//                           }
//                           title={amenity.amenity_name}
//                         >
//                           {amenity.amenity_icon ? (
//                             <img
//                               src={amenity.amenity_icon_url}
//                               alt={amenity.amenity_name}
//                               className="amenity-icon"
//                             />
//                           ) : (
//                             <FontAwesomeIcon
//                               icon={faConciergeBell}
//                               className="amenity-icon-fa"
//                             />
//                           )}
//                           <span className="amenity-name">
//                             {amenity.amenity_name}
//                           </span>
//                           {amenity.amenity_image && (
//                             <span className="amenity-expand-hint">
//                               <FontAwesomeIcon icon={faExpand} />
//                             </span>
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                     <button
//                       className="project-card__cta mt-3"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         navigate(withTenant(`/location/${project.id}`));
//                       }}
//                     >
//                       Explore Project
//                       <FontAwesomeIcon
//                         icon={faArrowRight}
//                         className="cta-arrow"
//                       />
//                     </button>
//                   </div>
//                 )}

//                 {/* Walkthrough */}
//                 {activeTab[project.id] === "walkthrough" && (
//                   <div className="tab-content tour-tab">
//                     <h4 className="tab-heading">Walkthrough</h4>
//                     {project.walkthroughs.map((wt, i) => (
//                       <div
//                         key={i}
//                         className="tour-preview"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           window.open(wt.walkthrough_url, "_blank");
//                         }}
//                       >
//                         <FontAwesomeIcon
//                           icon={faWalking}
//                           className="tour-play-icon"
//                         />
//                         <span>{wt.title || `Walkthrough ${i + 1}`}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* 360° Tour */}
//                 {activeTab[project.id] === "tour" && (
//                   <div className="tab-content tour-tab">
//                     <h4 className="tab-heading">360° Virtual Tour</h4>
//                     {project.virtual_tours.map((vt, i) => (
//                       <div
//                         key={i}
//                         className="tour-preview"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           window.open(vt.tour_url, "_blank");
//                         }}
//                       >
//                         <FontAwesomeIcon
//                           icon={faVrCardboard}
//                           className="tour-play-icon"
//                         />
//                         <span>{vt.title || `360° Tour ${i + 1}`}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </article>
//         ))}
//       </div>

//       {/* ── Amenity Modal ───────────────────────────────── */}
//       {amenityModal && (
//         <div className="amenity-modal-overlay" onClick={closeAmenityModal}>
//           <div className="amenity-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="amenity-modal__header">
//               <h5>{amenityModal.projectName} — Amenities</h5>
//               <button className="modal-close-btn" onClick={closeAmenityModal}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>

//             <div className="amenity-modal__stage">
//               {amenityModal.amenities.length > 1 && (
//                 <button
//                   className="amenity-modal__nav amenity-modal__nav--prev"
//                   onClick={prevAmenity}
//                 >
//                   <FontAwesomeIcon
//                     icon={faArrowRight}
//                     style={{ transform: "rotate(180deg)" }}
//                   />
//                 </button>
//               )}

//               <div className="amenity-modal__image-wrap">
//                 {amenityModal.amenities[amenityModal.currentIndex]
//                   ?.amenity_image ? (
//                   <img
//                     key={amenityModal.currentIndex}
//                     src={
//                       amenityModal.amenities[amenityModal.currentIndex]
//                         .amenity_image_url
//                     }
//                     alt={
//                       amenityModal.amenities[amenityModal.currentIndex]
//                         .amenity_name
//                     }
//                     className="amenity-modal__image"
//                   />
//                 ) : (
//                   <div className="amenity-modal__no-image">
//                     <FontAwesomeIcon icon={faConciergeBell} />
//                     <span>No image available</span>
//                   </div>
//                 )}

//                 <div className="amenity-modal__name-overlay">
//                   {amenityModal.amenities[amenityModal.currentIndex]
//                     ?.amenity_icon && (
//                     <img
//                       src={
//                         amenityModal.amenities[amenityModal.currentIndex]
//                           .amenity_icon_url
//                       }
//                       alt="icon"
//                       className="amenity-modal__icon-badge"
//                     />
//                   )}
//                   <span className="amenity-modal__name">
//                     {
//                       amenityModal.amenities[amenityModal.currentIndex]
//                         ?.amenity_name
//                     }
//                   </span>
//                   <span className="amenity-modal__counter">
//                     {amenityModal.currentIndex + 1} /{" "}
//                     {amenityModal.amenities.length}
//                   </span>
//                 </div>
//               </div>

//               {amenityModal.amenities.length > 1 && (
//                 <button
//                   className="amenity-modal__nav amenity-modal__nav--next"
//                   onClick={nextAmenity}
//                 >
//                   <FontAwesomeIcon icon={faArrowRight} />
//                 </button>
//               )}
//             </div>

//             {amenityModal.amenities.length > 1 && (
//               <div className="amenity-modal__thumbs">
//                 {amenityModal.amenities.map((amenity, i) => (
//                   <div
//                     key={i}
//                     className={`amenity-thumb ${i === amenityModal.currentIndex ? "active" : ""}`}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setAmenityModal((prev) => ({
//                         ...prev,
//                         currentIndex: i,
//                       }));
//                     }}
//                   >
//                     {amenity.amenity_icon ? (
//                       <img
//                         src={amenity.amenity_icon_url}
//                         alt={amenity.amenity_name}
//                         className="amenity-thumb__icon"
//                       />
//                     ) : (
//                       <FontAwesomeIcon
//                         icon={faConciergeBell}
//                         className="amenity-thumb__fa"
//                       />
//                     )}
//                     <span className="amenity-thumb__name">
//                       {amenity.amenity_name}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* ── Brochure Modal ──────────────────────────────── */}
//       {brochureModal && (
//         <div className="brochure-modal-overlay" onClick={closeBrochure}>
//           <div className="brochure-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="brochure-modal__header">
//               <h5>{brochureModal.name}</h5>
//               <button className="modal-close-btn" onClick={closeBrochure}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>
//             <div className="brochure-modal__body">
//               <iframe
//                 src={brochureModal.url}
//                 title="Brochure"
//                 width="100%"
//                 height="100%"
//                 style={{ border: "none" }}
//               />
//             </div>
//             <div className="brochure-modal__footer">
//               <a
//                 href={brochureModal.url}
//                 download
//                 className="project-card__cta"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <FontAwesomeIcon icon={faFileAlt} />
//                 Download PDF
//               </a>
//             </div>
//           </div>
//         </div>
//       )}
//     </main>
//   );
// };

// export default ProjectsLayout;

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faMapMarkerAlt,
//   faArrowRight,
//   faVrCardboard,
//   faFileAlt,
//   faWalking,
//   faConciergeBell,
//   faTimes,
//   faExpand,
//   faCog,
//   faSpinner,
//   faBuilding,
//   faWandMagicSparkles,
// } from "@fortawesome/free-solid-svg-icons";
// import { apiJson } from "../api/apiClient";
// import { apiUrl, imgUrl } from "../apiUrl";
// import "../styles/ProjectsLayout.css";
// // import AIChatWidget from "./AIChatWidget";
// const ApiUrl = apiUrl;
// const API_BASE = `${apiUrl}/api`;

// // Where the "Register" button on the no-tenant screen sends people.
// // Set REACT_APP_LANDING_URL in your .env.
// const LANDING_URL = process.env.REACT_APP_LANDING_URL || "#";

// const ProjectsLayout = () => {
//   const navigate = useNavigate();
//   const { tenant } = useParams();

//   const withTenant = (path) => `/${tenant}${path}`;

//   const [projects, setProjects] = useState([]);
//   const [settings, setSettings] = useState({});
//   const [platformSettings, setPlatformSettings] = useState({});
//   const [hoveredId, setHoveredId] = useState(null);
//   const [activeTab, setActiveTab] = useState({});
//   const [brochureModal, setBrochureModal] = useState(null);
//   const [amenityModal, setAmenityModal] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [isSetupComplete, setIsSetupComplete] = useState(false);
//   const [settingsLoaded, setSettingsLoaded] = useState(false);
//   const [projectsLoaded, setProjectsLoaded] = useState(false);

//   const [minDisplayElapsed, setMinDisplayElapsed] = useState(false);

//   // Fetch failures (bad slug, tenant deleted, server down) are tracked
//   // separately from "setup incomplete" — those are different messages.
//   const [settingsError, setSettingsError] = useState(null);
//   const [projectsError, setProjectsError] = useState(null);

//   // ── Staged loading progress (mirrors ApartmentViewer's loadProgress) ──
//   const [loadProgress, setLoadProgress] = useState(0);
//   // Header fades/slides in once everything is actually ready to show.
//   const [headerVisible, setHeaderVisible] = useState(false);
//   // Full-screen fade shown briefly before an internal navigation.
//   const [isTransitioning, setIsTransitioning] = useState(false);
//   // Which project cards have scrolled into view (per-card reveal).
//   const [visibleCards, setVisibleCards] = useState({});
//   const cardRefs = useRef({});
//   const cardObserver = useRef(null);
//   // Set once AIChatWidget mounts, so card buttons can open it pre-scoped
//   // to that project without lifting all the chat state up into this file.
//   const aiChatRef = useRef(null);

//   // Navigate after a brief fade, so the route change reads as one
//   // continuous motion instead of an instant jump-cut.
//   const navigateWithTransition = (path) => {
//     setIsTransitioning(true);
//     window.setTimeout(() => navigate(path), 380);
//   };

//   // ── Amenity modal handlers ─────────────────────────────
//   const openAmenityModal = (e, amenities, projectName, startIndex = 0) => {
//     e.stopPropagation();
//     setAmenityModal({ amenities, currentIndex: startIndex, projectName });
//   };
//   const closeAmenityModal = () => setAmenityModal(null);

//   const prevAmenity = (e) => {
//     if (e) e.stopPropagation();
//     setAmenityModal((prev) => ({
//       ...prev,
//       currentIndex:
//         prev.currentIndex === 0
//           ? prev.amenities.length - 1
//           : prev.currentIndex - 1,
//     }));
//   };

//   const nextAmenity = (e) => {
//     if (e) e.stopPropagation();
//     setAmenityModal((prev) => ({
//       ...prev,
//       currentIndex:
//         prev.currentIndex === prev.amenities.length - 1
//           ? 0
//           : prev.currentIndex + 1,
//     }));
//   };

//   // ── Brochure modal handlers ────────────────────────────
//   const openBrochure = (e, url, name) => {
//     e.stopPropagation();
//     setBrochureModal({ url, name });
//   };
//   const closeBrochure = () => setBrochureModal(null);

//   // ── Tab handler ────────────────────────────────────────
//   const handleTabChange = (projectId, tab, e) => {
//     e.stopPropagation();
//     setActiveTab((prev) => ({ ...prev, [projectId]: tab }));
//   };

//   // ── Body class ─────────────────────────────────────────
//   useEffect(() => {
//     document.body.classList.add("projects-page-active");
//     return () => document.body.classList.remove("projects-page-active");
//   }, []);

//   // ── Simulated staged progress while settings/projects load ────
//   // Climbs to 90% on its own (like ApartmentViewer's loader), then jumps
//   // to 100% the moment both fetches actually resolve.
//   useEffect(() => {
//     const t = window.setTimeout(() => setMinDisplayElapsed(true), 500);
//     return () => window.clearTimeout(t);
//   }, []);

//   const showOverlay = isLoading || !minDisplayElapsed;

//   useEffect(() => {
//     if (!isLoading) return;
//     const interval = setInterval(() => {
//       setLoadProgress((p) => {
//         if (p >= 90) return 90;
//         return Math.min(90, p + Math.random() * 18);
//       });
//     }, 180);
//     return () => clearInterval(interval);
//   }, [isLoading]);

//   // ── Fetch settings ─────────────────────────────────────
//   useEffect(() => {
//     if (!tenant) return;

//     const fetchSettings = async () => {
//       try {
//         const data = await apiJson(tenant, "/settings");
//         setSettings(data);
//         setSettingsLoaded(true);
//       } catch (err) {
//         console.error("Error fetching settings:", err);
//         setSettingsError(err.message || "Failed to load settings.");
//         setSettingsLoaded(true);
//       }
//     };

//     fetchSettings();
//   }, [tenant]);

//   // ── Fetch Platform settings ─────────────────────────────────────
//   useEffect(() => {
//     const fetchPlatformSettings = async () => {
//       try {
//         const response = await fetch(`${API_BASE}/platform-settings`);

//         if (!response.ok) {
//           throw new Error(`HTTP ${response.status}`);
//         }

//         const platformData = await response.json();
//         setPlatformSettings(platformData);
//       } catch (err) {
//         console.error("Error fetching platform settings:", err);
//       }
//     };

//     fetchPlatformSettings();
//   }, []);

//   // ── Fetch projects ─────────────────────────────────────
//   useEffect(() => {
//     if (!tenant) return;

//     const fetchProjects = async () => {
//       try {
//         const data = await apiJson(tenant, "/all-projects");
//         setProjects(data);

//         const tabs = {};
//         data.forEach((p) => (tabs[p.id] = "overview"));
//         setActiveTab(tabs);
//         setProjectsLoaded(true);
//       } catch (err) {
//         console.error("Error fetching projects:", err);
//         setProjects([]);
//         setProjectsError(err.message || "Failed to load projects.");
//         setProjectsLoaded(true);
//       }
//     };

//     fetchProjects();
//   }, [tenant]);

//   // ── Check setup completion when both settings and projects are loaded ──
//   useEffect(() => {
//     // Only check when both settings and projects are loaded
//     if (!settingsLoaded || !projectsLoaded) {
//       return;
//     }

//     // Check if tenant has completed setup
//     const hasCompanyName =
//       settings.company_name && settings.company_name.trim() !== "";
//     const hasLogo =
//       settings.logo_dark_url && settings.logo_dark_url.trim() !== "";
//     const hasProjects = projects.length > 0;

//     const setupComplete = hasCompanyName && hasLogo && hasProjects;

//     // Finish the progress bar, then swap from loading -> content just after,
//     // so the 100% tick is actually visible instead of being skipped.
//     setLoadProgress(100);
//     const t = window.setTimeout(() => {
//       setIsSetupComplete(setupComplete);
//       setIsLoading(false);
//     }, 300);
//     return () => window.clearTimeout(t);
//   }, [settingsLoaded, projectsLoaded, settings, projects]);

//   // ── Reveal the header once the main view actually mounts ──────
//   useEffect(() => {
//     if (isLoading || !isSetupComplete) return;
//     const t = window.setTimeout(() => setHeaderVisible(true), 60);
//     return () => window.clearTimeout(t);
//   }, [isLoading, isSetupComplete]);

//   // ── Per-card scroll reveal ──────────────────────────────
//   const registerCardRef = useCallback(
//     (projectId) => (el) => {
//       if (!el) return;
//       cardRefs.current[projectId] = el;
//       if (cardObserver.current) {
//         cardObserver.current.observe(el);
//       }
//     },
//     [],
//   );

//   useEffect(() => {
//     if (!projects.length) return;

//     cardObserver.current = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             const id = entry.target.getAttribute("data-project-id");
//             setVisibleCards((prev) =>
//               prev[id] ? prev : { ...prev, [id]: true },
//             );
//             cardObserver.current.unobserve(entry.target);
//           }
//         });
//       },
//       { threshold: 0.15, rootMargin: "0px 0px -60px 0px" },
//     );

//     Object.values(cardRefs.current).forEach((el) => {
//       if (el) cardObserver.current.observe(el);
//     });

//     return () => cardObserver.current && cardObserver.current.disconnect();
//   }, [projects]);

//   // ── Keyboard nav: amenity modal ────────────────────────
//   useEffect(() => {
//     if (!amenityModal) return;
//     const handleKey = (e) => {
//       if (e.key === "ArrowLeft") prevAmenity(null);
//       if (e.key === "ArrowRight") nextAmenity(null);
//       if (e.key === "Escape") closeAmenityModal();
//     };
//     window.addEventListener("keydown", handleKey);
//     return () => window.removeEventListener("keydown", handleKey);
//   }, [amenityModal]);

//   // ── Keyboard nav: brochure modal ───────────────────────
//   useEffect(() => {
//     if (!brochureModal) return;
//     const handleKey = (e) => {
//       if (e.key === "Escape") closeBrochure();
//     };
//     window.addEventListener("keydown", handleKey);
//     return () => window.removeEventListener("keydown", handleKey);
//   }, [brochureModal]);

//   // ── Apply theme from settings ──────────────────────────
//   useEffect(() => {
//     if (!settings) return;
//     const root = document.documentElement;
//     if (settings.primary_color)
//       root.style.setProperty("--primary-color", settings.primary_color);
//     if (settings.primary_color_hover)
//       root.style.setProperty("--primary-hover", settings.primary_color_hover);
//     if (settings.accent_color)
//       root.style.setProperty("--accent-color", settings.accent_color);
//     if (settings.text_color_dark)
//       root.style.setProperty("--text-dark", settings.text_color_dark);
//     if (settings.text_color_muted)
//       root.style.setProperty("--text-muted", settings.text_color_muted);
//     if (settings.card_border_color)
//       root.style.setProperty("--card-border", settings.card_border_color);
//     if (settings.page_bg_color)
//       root.style.setProperty("--page-bg", settings.page_bg_color);
//     if (settings.card_bg_color)
//       root.style.setProperty("--card-bg", settings.card_bg_color);
//     if (settings.heading_font)
//       root.style.setProperty("--font-heading", settings.heading_font);
//     if (settings.body_font)
//       root.style.setProperty("--font-body", settings.body_font);
//     if (settings.google_fonts_url) {
//       let link = document.getElementById("dynamic-google-fonts");
//       if (!link) {
//         link = document.createElement("link");
//         link.id = "dynamic-google-fonts";
//         link.rel = "stylesheet";
//         document.head.appendChild(link);
//       }
//       link.href = settings.google_fonts_url;
//     }
//   }, [settings]);

//   // ── No tenant in the URL at all ─────────────────────────
//   // Someone hit the bare domain instead of the link from their welcome
//   // email. Checked before everything else — no point loading anything
//   // if there's no tenant to load it for.
//   if (!tenant) {
//     return (
//       <main className="projects-page projects-page--no-tenant">
//         <div
//           style={{
//             minHeight: "100vh",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             textAlign: "center",
//             padding: "40px 20px",
//           }}
//         >
//           <FontAwesomeIcon
//             icon={faBuilding}
//             style={{ fontSize: 48, marginBottom: 24, opacity: 0.4 }}
//           />
//           <h1 style={{ marginBottom: 12 }}>No site selected</h1>
//           <p style={{ maxWidth: 440, marginBottom: 28, color: "#6c757d" }}>
//             This link doesn't point to a registered account. If you've already
//             signed up, check the welcome email we sent you when you registered
//             for your site's direct link. Otherwise, register to get your own
//             site set up.
//           </p>
//           <a
//             href={LANDING_URL}
//             className="project-card__cta"
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 8,
//               alignSelf: "center",
//             }}
//           >
//             Register / Contact us
//             <FontAwesomeIcon icon={faArrowRight} className="cta-arrow" />
//           </a>
//         </div>
//       </main>
//     );
//   }

//   // ── Couldn't reach the server / bad tenant slug ────────
//   // Distinct from "setup incomplete" — this is a real fetch failure,
//   // not a tenant who simply hasn't finished onboarding yet.
//   if (settingsError && projectsError) {
//     const isTenantNotFound =
//       settingsError.toLowerCase().includes("tenant") ||
//       projectsError.toLowerCase().includes("tenant");

//     return (
//       <main className="projects-page">
//         <div
//           style={{
//             minHeight: "100vh",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             textAlign: "center",
//             padding: "40px 20px",
//           }}
//         >
//           <FontAwesomeIcon
//             icon={faBuilding}
//             style={{ fontSize: 48, marginBottom: 24, opacity: 0.4 }}
//           />
//           <h1 style={{ marginBottom: 12 }}>We couldn't load this site</h1>
//           <p style={{ maxWidth: 440, color: "#6c757d" }}>
//             {isTenantNotFound
//               ? "This link doesn't match a registered account. Please check the URL, or contact us if you believe this is a mistake."
//               : "Something went wrong on our end. Please try again in a moment."}
//           </p>
//         </div>
//       </main>
//     );
//   }

//   // ── Loading overlay — mirrors ApartmentViewer's .viewer-loading /
//   // -hidden pattern: it sits on top of whatever screen is already mounted
//   // (welcome or the main grid) and fades away once loading finishes,
//   // instead of swapping the whole screen out from under it.
//   // const loadingOverlay = (
//   //   <div className={`projects-loading-overlay ${!isLoading ? "is-hidden" : ""}`}>
//   //     <div className="projects-loading-card">
//   //       <FontAwesomeIcon icon={faBuilding} className="projects-loading-icon" />
//   //       <div className="projects-loading-percent">{Math.round(loadProgress)}%</div>
//   //       <div className="projects-loading-bar">
//   //         <div
//   //           className="projects-loading-bar-fill"
//   //           style={{ width: `${loadProgress}%` }}
//   //         />
//   //       </div>
//   //       <div className="projects-loading-text">
//   //         {loadProgress < 30 && "Initializing"}
//   //         {loadProgress >= 30 && loadProgress < 60 && "Loading settings"}
//   //         {loadProgress >= 60 && loadProgress < 90 && "Loading properties"}
//   //         {loadProgress >= 90 && loadProgress < 100 && "Almost ready"}
//   //         {loadProgress >= 100 && "Ready"}
//   //       </div>
//   //     </div>
//   //   </div>
//   // );

//  const loadingLogoSrc = settings.logo_dark_url || null;

// const loadingMonogramLetter = (settings.company_name || "")[0] || "";

// const loadingOverlay = (
//   <div className={`projects-loading-overlay ${!showOverlay ? "is-hidden" : ""}`}>
//     <div className="projects-loading-card">
//       {loadingLogoSrc ? (
//         <img
//           src={loadingLogoSrc}
//           alt={settings.company_name || "Logo"}
//           className="projects-loading-logo"
//         />
//       ) : (
//         <div className="projects-loading-mark">
//           {loadingMonogramLetter || (
//             <FontAwesomeIcon icon={faBuilding} style={{ fontSize: 18, opacity: 0.5 }} />
//           )}
//         </div>
//       )}

//       <div className="projects-loading-rule">
//         <div
//           className="projects-loading-rule__fill"
//           style={{ width: `${loadProgress}%` }}
//         />
//       </div>

//       <div className="projects-loading-label">
//         {loadProgress < 100 ? "Preparing your experience" : "Ready"}
//       </div>
//     </div>
//   </div>
// );

//   // ── Welcome / Setup Required State ────────────────────
//   if (!isSetupComplete) {
//     return (
//       <main className="projects-page">
//         <div className="projects-welcome-container">
//           <div className="projects-welcome">
//             <div className="welcome-logo">
//               {platformSettings.app_logo_dark_url ? (
//                 <img
//                   src={platformSettings.app_logo_dark_url}
//                   alt="Platform Logo"
//                   className="platform-logo"
//                 />
//               ) : (
//                 <div className="platform-logo-placeholder">
//                   <FontAwesomeIcon icon={faCog} size="4x" />
//                 </div>
//               )}
//             </div>

//             <h1 className="welcome-title">
//               Welcome to <span className="highlight">Your App</span>
//             </h1>

//             <p className="welcome-subtitle">
//               Your tenant setup is not yet complete. Please complete the
//               following steps to start showcasing your properties.
//             </p>

//             <div className="welcome-steps">
//               <div className="welcome-step">
//                 <div className="step-number">1</div>
//                 <div className="step-content">
//                   <h3>Add Company Information</h3>
//                   <p>Set up your company name, logo, and branding details</p>
//                 </div>
//               </div>

//               <div className="welcome-step">
//                 <div className="step-number">2</div>
//                 <div className="step-content">
//                   <h3>Configure Settings</h3>
//                   <p>Choose colors, fonts, and design preferences</p>
//                 </div>
//               </div>

//               <div className="welcome-step">
//                 <div className="step-number">3</div>
//                 <div className="step-content">
//                   <h3>Add Your Properties</h3>
//                   <p>
//                     Create your first project with details, images, and
//                     amenities
//                   </p>
//                 </div>
//               </div>
//             </div>

//             <div className="welcome-actions">
//               <button
//                 className="welcome-cta"
//                 onClick={() => {
//                   window.open(
//                     `${ApiUrl}/${tenant}/admin/login-form`,
//                     "_blank",
//                     "noopener,noreferrer",
//                   );
//                 }}
//               >
//                 Start Setup
//                 <FontAwesomeIcon icon={faArrowRight} className="cta-arrow" />
//               </button>
//             </div>
//           </div>
//         </div>

//         {loadingOverlay}
//       </main>
//     );
//   }

//   // ── Main Projects View (when setup is complete) ──────
//   return (
//     <main className="projects-page">
//       {/* ── Full-screen Split Header ─────────────────────── */}
//       <header
//         className={`projects-header ${headerVisible ? "is-visible" : ""}`}
//       >
//         {/* Left: Text */}
//         <div className="projects-header__left">
//           {settings.logo_dark_url && (
//             <div className="logo-img-div">
//               <img
//                 src={settings.logo_dark_url}
//                 alt={settings.company_name || "Logo"}
//                 className="projects-logo"
//               />
//             </div>
//           )}

//           <div className="projects-eyebrow-wrap">
//             <span className="projects-eyebrow__line" />
//             <span className="projects-eyebrow">
//               {settings.app_eyebrow || "Our Portfolio"}
//             </span>
//           </div>

//           <h1 className="projects-title">
//             {settings.app_tagline || "Exceptional"}
//             <em>{settings.app_tagline_italic || "Properties"}</em>
//           </h1>

//           <p className="projects-subtitle">
//             {settings.app_subtitle ||
//               "Discover handcrafted developments built for modern living"}
//           </p>

//           <div className="projects-header__scroll">
//             <span className="projects-header__scroll-line" />
//             Explore below
//           </div>
//         </div>

//         {/* Divider */}
//         <div className="projects-header__divider" />

//         {/* Right: Hero image — use first project's image if available */}
//         {projects.length > 0 && (
//           <div className="projects-header__right">
//             <img
//               src={projects[0].project_image_url}
//               alt={projects[0].project_name}
//               className="projects-header__hero-img"
//             />
//           </div>
//         )}
//       </header>

//       {/* ── Section label ───────────────────────────────── */}
//       <div className="projects-section-label">
//         <h2 className="projects-section-label__text">
//           All <em>Residences</em>
//         </h2>
//         {projects.length > 0 && (
//           <span className="projects-section-label__count">
//             {String(projects.length).padStart(2, "0")} Properties
//           </span>
//         )}
//       </div>

//       {/* ── Projects: Full-width split rows ─────────────── */}
//       <div className="projects-grid">
//         {projects.map((project, index) => (
//           <article
//             key={project.id}
//             ref={registerCardRef(project.id)}
//             data-project-id={project.id}
//             className={`project-card ${visibleCards[project.id] ? "in-view" : ""} ${
//               hoveredId === project.id ? "is-hovered" : ""
//             }`}
//             style={{ transitionDelay: `${Math.min(index, 4) * 90}ms` }}
//             onMouseEnter={() => setHoveredId(project.id)}
//             onMouseLeave={() => setHoveredId(null)}
//           >
//             {/* ── Image Panel ──────────────────────────── */}
//             <div
//               className="project-card__image-panel"
//               onClick={() =>
//                 !project.is_upcoming &&
//                 navigateWithTransition(withTenant(`/location/${project.id}`))
//               }
//               style={{ cursor: project.is_upcoming ? "default" : "pointer" }}
//             >
//               <img
//                 src={project.project_image_url}
//                 alt={project.project_name}
//                 className="project-card__image"
//               />
//               <div className="project-card__image-overlay" />
//               {project.is_upcoming && (
//                 <div className="project-card__upcoming-badge">
//                   <span className="upcoming-badge__pulse" />
//                   <span className="upcoming-badge__text">Coming Soon</span>
//                 </div>
//               )}

//               {/* Logo overlaid on image */}
//               <div className="project-card__logo-wrap">
//                 <img
//                   src={project.logo_url}
//                   alt={`${project.project_name} logo`}
//                   className="project-card__logo"
//                 />
//               </div>
//             </div>

//             {/* ── Content Panel ────────────────────────── */}
//             <div
//               className="project-card__panel"
//               data-index={String(index + 1).padStart(2, "0")}
//             >
//               {/* Tabs */}
//               <div
//                 className="project-card__tabs"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <button
//                   className={`tab-btn ${activeTab[project.id] === "overview" ? "active" : ""}`}
//                   onClick={(e) => handleTabChange(project.id, "overview", e)}
//                 >
//                   Overview
//                 </button>

//                 {project.amenities_count > 0 && (
//                   <button
//                     className={`tab-btn ${activeTab[project.id] === "amenities" ? "active" : ""}`}
//                     onClick={(e) => handleTabChange(project.id, "amenities", e)}
//                   >
//                     <FontAwesomeIcon
//                       icon={faConciergeBell}
//                       className="tab-icon"
//                     />
//                     Amenities
//                   </button>
//                 )}

//                 {project.walkthroughs?.length > 0 && (
//                   <button
//                     className={`tab-btn ${activeTab[project.id] === "walkthrough" ? "active" : ""}`}
//                     onClick={(e) =>
//                       handleTabChange(project.id, "walkthrough", e)
//                     }
//                   >
//                     <FontAwesomeIcon icon={faWalking} className="tab-icon" />
//                     Walk
//                   </button>
//                 )}

//                 {project.virtual_tours?.length > 0 && (
//                   <button
//                     className={`tab-btn ${activeTab[project.id] === "tour" ? "active" : ""}`}
//                     onClick={(e) => handleTabChange(project.id, "tour", e)}
//                   >
//                     <FontAwesomeIcon
//                       icon={faVrCardboard}
//                       className="tab-icon"
//                     />
//                     360°
//                   </button>
//                 )}
//               </div>

//               {/* Tab Content */}
//               <div className="project-card__content">
//                 {/* Overview */}
//                 {activeTab[project.id] === "overview" && (
//                   <div className="tab-content">
//                     <div className="project-card__location">
//                       <FontAwesomeIcon
//                         icon={faMapMarkerAlt}
//                         className="pin-icon"
//                       />
//                       <span>{project.location}</span>
//                     </div>

//                     <h3 className="project-card__name">
//                       {project.project_name}
//                     </h3>

//                     {project.description && (
//                       <p className="project-card__description">
//                         {project.description}
//                       </p>
//                     )}

//                     <div className="project-card__actions">
//                       {project.is_upcoming ? (
//                         <div className="project-card__upcoming-info">
//                           <span className="upcoming-info__dot" />
//                           <span className="upcoming-info__text">
//                             Booking opening soon
//                           </span>
//                         </div>
//                       ) : (
//                         <button
//                           className="project-card__cta"
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             navigateWithTransition(
//                               withTenant(`/location/${project.id}`),
//                             );
//                           }}
//                         >
//                           Choose Your Units
//                           <FontAwesomeIcon
//                             icon={faArrowRight}
//                             className="cta-arrow"
//                           />
//                         </button>
//                       )}
//                       {!project.is_upcoming && (
//                         <div className="project-card__icon-actions">
//                           {/* <button
//                             className="project-card__icon-btn"
//                             title="Ask AI about this property"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               aiChatRef.current?.openWithProject(project);
//                             }}
//                           >
//                             <FontAwesomeIcon icon={faWandMagicSparkles} />
//                             <span>Ask AI</span>
//                           </button> */}

//                           {project.master_plan_id && (
//                             <button
//                               className="project-card__icon-btn"
//                               title="360° Panorama"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 navigateWithTransition(
//                                   withTenant(
//                                     `/apartment-view/${project.master_plan_id}`,
//                                   ),
//                                 );
//                               }}
//                             >
//                               <FontAwesomeIcon icon={faVrCardboard} />
//                               <span>Panorama</span>
//                             </button>
//                           )}

//                           {project.walkthroughs?.length > 0 && (
//                             <button
//                               className="project-card__icon-btn"
//                               title="Walkthrough"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 window.open(
//                                   project.walkthroughs[0].walkthrough_url,
//                                   "_blank",
//                                 );
//                               }}
//                             >
//                               <FontAwesomeIcon icon={faWalking} />
//                               <span>Walkthrough</span>
//                             </button>
//                           )}

//                           {project.virtual_tours?.length > 0 && (
//                             <button
//                               className="project-card__icon-btn"
//                               title="Virtual Tour"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 window.open(
//                                   project.virtual_tours[0].tour_url,
//                                   "_blank",
//                                 );
//                               }}
//                             >
//                               <FontAwesomeIcon icon={faVrCardboard} />
//                               <span>360° Tour</span>
//                             </button>
//                           )}

//                           {project.brochures?.length > 0 && (
//                             <button
//                               className="project-card__icon-btn"
//                               title="Brochure"
//                               onClick={(e) =>
//                                 openBrochure(
//                                   e,
//                                   project.brochures[0].brochure_url,
//                                   project.brochures[0].title ||
//                                     project.project_name,
//                                 )
//                               }
//                             >
//                               <FontAwesomeIcon icon={faFileAlt} />
//                               <span>Brochure</span>
//                             </button>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 )}

//                 {/* Amenities */}
//                 {activeTab[project.id] === "amenities" && (
//                   <div className="tab-content amenities-tab">
//                     <div className="amenities-grid">
//                       {project.amenities?.map((amenity, i) => (
//                         <div
//                           key={i}
//                           className="amenity-item"
//                           onClick={(e) =>
//                             openAmenityModal(
//                               e,
//                               project.amenities,
//                               project.project_name,
//                               i,
//                             )
//                           }
//                           title={amenity.amenity_name}
//                         >
//                           {amenity.amenity_icon ? (
//                             <img
//                               src={amenity.amenity_icon_url}
//                               alt={amenity.amenity_name}
//                               className="amenity-icon"
//                             />
//                           ) : (
//                             <FontAwesomeIcon
//                               icon={faConciergeBell}
//                               className="amenity-icon-fa"
//                             />
//                           )}
//                           <span className="amenity-name">
//                             {amenity.amenity_name}
//                           </span>
//                           {amenity.amenity_image && (
//                             <span className="amenity-expand-hint">
//                               <FontAwesomeIcon icon={faExpand} />
//                             </span>
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                     <button
//                       className="project-card__cta mt-3"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         navigateWithTransition(
//                           withTenant(`/location/${project.id}`),
//                         );
//                       }}
//                     >
//                       Explore Project
//                       <FontAwesomeIcon
//                         icon={faArrowRight}
//                         className="cta-arrow"
//                       />
//                     </button>
//                   </div>
//                 )}

//                 {/* Walkthrough */}
//                 {activeTab[project.id] === "walkthrough" && (
//                   <div className="tab-content tour-tab">
//                     <h4 className="tab-heading">Walkthrough</h4>
//                     {project.walkthroughs.map((wt, i) => (
//                       <div
//                         key={i}
//                         className="tour-preview"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           window.open(wt.walkthrough_url, "_blank");
//                         }}
//                       >
//                         <FontAwesomeIcon
//                           icon={faWalking}
//                           className="tour-play-icon"
//                         />
//                         <span>{wt.title || `Walkthrough ${i + 1}`}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* 360° Tour */}
//                 {activeTab[project.id] === "tour" && (
//                   <div className="tab-content tour-tab">
//                     <h4 className="tab-heading">360° Virtual Tour</h4>
//                     {project.virtual_tours.map((vt, i) => (
//                       <div
//                         key={i}
//                         className="tour-preview"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           window.open(vt.tour_url, "_blank");
//                         }}
//                       >
//                         <FontAwesomeIcon
//                           icon={faVrCardboard}
//                           className="tour-play-icon"
//                         />
//                         <span>{vt.title || `360° Tour ${i + 1}`}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </article>
//         ))}
//       </div>

//       {/* ── Amenity Modal ───────────────────────────────── */}
//       {amenityModal && (
//         <div className="amenity-modal-overlay" onClick={closeAmenityModal}>
//           <div className="amenity-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="amenity-modal__header">
//               <h5>{amenityModal.projectName} — Amenities</h5>
//               <button className="modal-close-btn" onClick={closeAmenityModal}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>

//             <div className="amenity-modal__stage">
//               {amenityModal.amenities.length > 1 && (
//                 <button
//                   className="amenity-modal__nav amenity-modal__nav--prev"
//                   onClick={prevAmenity}
//                 >
//                   <FontAwesomeIcon
//                     icon={faArrowRight}
//                     style={{ transform: "rotate(180deg)" }}
//                   />
//                 </button>
//               )}

//               <div className="amenity-modal__image-wrap">
//                 {amenityModal.amenities[amenityModal.currentIndex]
//                   ?.amenity_image ? (
//                   <img
//                     key={amenityModal.currentIndex}
//                     src={
//                       amenityModal.amenities[amenityModal.currentIndex]
//                         .amenity_image_url
//                     }
//                     alt={
//                       amenityModal.amenities[amenityModal.currentIndex]
//                         .amenity_name
//                     }
//                     className="amenity-modal__image"
//                   />
//                 ) : (
//                   <div className="amenity-modal__no-image">
//                     <FontAwesomeIcon icon={faConciergeBell} />
//                     <span>No image available</span>
//                   </div>
//                 )}

//                 <div className="amenity-modal__name-overlay">
//                   {amenityModal.amenities[amenityModal.currentIndex]
//                     ?.amenity_icon && (
//                     <img
//                       src={
//                         amenityModal.amenities[amenityModal.currentIndex]
//                           .amenity_icon_url
//                       }
//                       alt="icon"
//                       className="amenity-modal__icon-badge"
//                     />
//                   )}
//                   <span className="amenity-modal__name">
//                     {
//                       amenityModal.amenities[amenityModal.currentIndex]
//                         ?.amenity_name
//                     }
//                   </span>
//                   <span className="amenity-modal__counter">
//                     {amenityModal.currentIndex + 1} /{" "}
//                     {amenityModal.amenities.length}
//                   </span>
//                 </div>
//               </div>

//               {amenityModal.amenities.length > 1 && (
//                 <button
//                   className="amenity-modal__nav amenity-modal__nav--next"
//                   onClick={nextAmenity}
//                 >
//                   <FontAwesomeIcon icon={faArrowRight} />
//                 </button>
//               )}
//             </div>

//             {amenityModal.amenities.length > 1 && (
//               <div className="amenity-modal__thumbs">
//                 {amenityModal.amenities.map((amenity, i) => (
//                   <div
//                     key={i}
//                     className={`amenity-thumb ${i === amenityModal.currentIndex ? "active" : ""}`}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setAmenityModal((prev) => ({
//                         ...prev,
//                         currentIndex: i,
//                       }));
//                     }}
//                   >
//                     {amenity.amenity_icon ? (
//                       <img
//                         src={amenity.amenity_icon_url}
//                         alt={amenity.amenity_name}
//                         className="amenity-thumb__icon"
//                       />
//                     ) : (
//                       <FontAwesomeIcon
//                         icon={faConciergeBell}
//                         className="amenity-thumb__fa"
//                       />
//                     )}
//                     <span className="amenity-thumb__name">
//                       {amenity.amenity_name}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* ── Brochure Modal ──────────────────────────────── */}
//       {brochureModal && (
//         <div className="brochure-modal-overlay" onClick={closeBrochure}>
//           <div className="brochure-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="brochure-modal__header">
//               <h5>{brochureModal.name}</h5>
//               <button className="modal-close-btn" onClick={closeBrochure}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>
//             <div className="brochure-modal__body">
//               <iframe
//                 src={brochureModal.url}
//                 title="Brochure"
//                 width="100%"
//                 height="100%"
//                 style={{ border: "none" }}
//               />
//             </div>
//             <div className="brochure-modal__footer">
//               <a
//                 href={brochureModal.url}
//                 download
//                 className="project-card__cta"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <FontAwesomeIcon icon={faFileAlt} />
//                 Download PDF
//               </a>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Page-transition overlay ──────────────────────
//           Fades in before navigateWithTransition swaps the route
//           underneath it, so the change reads as one motion. */}
//       <div
//         className={`page-transition-overlay ${isTransitioning ? "is-active" : ""}`}
//         aria-hidden="true"
//       />

//       {loadingOverlay}

//       {/* ── AI chat widget ───────────────────────────────
//           Floating trigger for general questions; card "Ask AI" buttons
//           open it pre-scoped to that project via aiChatRef. */}
//       {/* <AIChatWidget
//         tenant={tenant}
//         projects={projects}
//         onReady={(api) => {
//           aiChatRef.current = api;
//         }}
//       /> */}
//     </main>
//   );
// };

// export default ProjectsLayout;

import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faArrowRight,
  faVrCardboard,
  faFileAlt,
  faWalking,
  faConciergeBell,
  faTimes,
  faExpand,
  faCog,
  faBuilding,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { apiJson } from "../api/apiClient";
import { apiUrl } from "../apiUrl";
import "../styles/ProjectsLayout.css";
// import AIChatWidget from "./AIChatWidget";
const ApiUrl = apiUrl;
const API_BASE = `${apiUrl}/api`;

// Where the "Register" button on the no-tenant screen sends people.
// Set REACT_APP_LANDING_URL in your .env.
const LANDING_URL = process.env.REACT_APP_LANDING_URL || "#";

// ── Tenant-scoped auth guard ────────────────────────────────────────────
// ASSUMPTION: logged-in user info lives in localStorage as `auth_user` /
// `auth_token`, tagged with the tenant it belongs to under `auth_tenant`.
// If you're using an AuthContext/Provider instead, move this exact check
// into that provider's init effect, keyed off the tenant from the URL —
// the principle (clear identity the instant the URL tenant doesn't match
// the stored tenant) is what matters, not where it physically lives.
const useTenantScopedAuth = (tenant) => {
  useEffect(() => {
    if (!tenant) return;
    try {
      const storedTenant = localStorage.getItem("auth_tenant");
      if (storedTenant && storedTenant !== tenant) {
        // Session belongs to a different tenant than the one being viewed —
        // never let this tenant's pages render another tenant's identity.
        localStorage.removeItem("auth_user");
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_tenant");
      }
    } catch (e) {
      console.warn("Tenant auth scope check failed:", e);
    }
  }, [tenant]);
};

const ProjectsLayout = () => {
  const navigate = useNavigate();
  const { tenant } = useParams();

  useTenantScopedAuth(tenant);

  const withTenant = (path) => `/${tenant}${path}`;

  const [projects, setProjects] = useState([]);
  const [settings, setSettings] = useState({});
  const [platformSettings, setPlatformSettings] = useState({});
  const [hoveredId, setHoveredId] = useState(null);
  const [activeTab, setActiveTab] = useState({});
  const [brochureModal, setBrochureModal] = useState(null);
  const [amenityModal, setAmenityModal] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSetupComplete, setIsSetupComplete] = useState(false);
  const [settingsLoaded, setSettingsLoaded] = useState(false);
  const [projectsLoaded, setProjectsLoaded] = useState(false);

  // Loading overlay must stay up for a minimum window once shown, so a
  // very fast load never flashes on then immediately off. It is NEVER
  // hidden while data is still actually loading, no matter what.
  const [minDisplayElapsed, setMinDisplayElapsed] = useState(false);

  // Fetch failures (bad slug, tenant deleted, server down) are tracked
  // separately from "setup incomplete" — those are different messages.
  const [settingsError, setSettingsError] = useState(null);
  const [projectsError, setProjectsError] = useState(null);

  // ── Staged loading progress (mirrors ApartmentViewer's loadProgress) ──
  const [loadProgress, setLoadProgress] = useState(0);
  // Header fades/slides in once everything is actually ready to show.
  const [headerVisible, setHeaderVisible] = useState(false);
  // Full-screen fade shown briefly before an internal navigation.
  const [isTransitioning, setIsTransitioning] = useState(false);
  // Which project cards have scrolled into view (per-card reveal).
  const [visibleCards, setVisibleCards] = useState({});
  const cardRefs = useRef({});
  const cardObserver = useRef(null);
  // Set once AIChatWidget mounts, so card buttons can open it pre-scoped
  // to that project without lifting all the chat state up into this file.
  const aiChatRef = useRef(null);

  // Navigate after a brief fade, so the route change reads as one
  // continuous motion instead of an instant jump-cut.
  const navigateWithTransition = (path) => {
    setIsTransitioning(true);
    window.setTimeout(() => navigate(path), 380);
  };

  // ── Amenity modal handlers ─────────────────────────────
  const openAmenityModal = (e, amenities, projectName, startIndex = 0) => {
    e.stopPropagation();
    setAmenityModal({ amenities, currentIndex: startIndex, projectName });
  };
  const closeAmenityModal = () => setAmenityModal(null);

  const prevAmenity = (e) => {
    if (e) e.stopPropagation();
    setAmenityModal((prev) => ({
      ...prev,
      currentIndex:
        prev.currentIndex === 0
          ? prev.amenities.length - 1
          : prev.currentIndex - 1,
    }));
  };

  const nextAmenity = (e) => {
    if (e) e.stopPropagation();
    setAmenityModal((prev) => ({
      ...prev,
      currentIndex:
        prev.currentIndex === prev.amenities.length - 1
          ? 0
          : prev.currentIndex + 1,
    }));
  };

  // ── Brochure modal handlers ────────────────────────────
  const openBrochure = (e, url, name) => {
    e.stopPropagation();
    setBrochureModal({ url, name });
  };
  const closeBrochure = () => setBrochureModal(null);

  // ── Tab handler ────────────────────────────────────────
  const handleTabChange = (projectId, tab, e) => {
    e.stopPropagation();
    setActiveTab((prev) => ({ ...prev, [projectId]: tab }));
  };

  // ── Body class ─────────────────────────────────────────
  useEffect(() => {
    document.body.classList.add("projects-page-active");
    return () => document.body.classList.remove("projects-page-active");
  }, []);

  // ── Minimum overlay display window ─────────────────────
  useEffect(() => {
    const t = window.setTimeout(() => setMinDisplayElapsed(true), 500);
    return () => window.clearTimeout(t);
  }, []);

  // ── Simulated staged progress while settings/projects load ────
  // Climbs to 90% on its own (like ApartmentViewer's loader), then jumps
  // to 100% the moment both fetches actually resolve.
  useEffect(() => {
    if (!isLoading) return;
    const interval = setInterval(() => {
      setLoadProgress((p) => {
        if (p >= 90) return 90;
        return Math.min(90, p + Math.random() * 18);
      });
    }, 180);
    return () => clearInterval(interval);
  }, [isLoading]);

  // ── Fetch settings ─────────────────────────────────────
  useEffect(() => {
    if (!tenant) return;

    const fetchSettings = async () => {
      try {
        const data = await apiJson(tenant, "/settings");
        setSettings(data);
        setSettingsLoaded(true);
      } catch (err) {
        console.error("Error fetching settings:", err);
        setSettingsError(err.message || "Failed to load settings.");
        setSettingsLoaded(true);
      }
    };

    fetchSettings();
  }, [tenant]);

  // ── Fetch Platform settings ─────────────────────────────────────
  useEffect(() => {
    const fetchPlatformSettings = async () => {
      try {
        const response = await fetch(`${API_BASE}/platform-settings`);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const platformData = await response.json();
        setPlatformSettings(platformData);
      } catch (err) {
        console.error("Error fetching platform settings:", err);
      }
    };

    fetchPlatformSettings();
  }, []);

  // ── Fetch projects ─────────────────────────────────────
  useEffect(() => {
    if (!tenant) return;

    const fetchProjects = async () => {
      try {
        const data = await apiJson(tenant, "/all-projects");
        setProjects(data);

        const tabs = {};
        data.forEach((p) => (tabs[p.id] = "overview"));
        setActiveTab(tabs);
        setProjectsLoaded(true);
      } catch (err) {
        console.error("Error fetching projects:", err);
        setProjects([]);
        setProjectsError(err.message || "Failed to load projects.");
        setProjectsLoaded(true);
      }
    };

    fetchProjects();
  }, [tenant]);

  // ── Check setup completion when both settings and projects are loaded ──
  useEffect(() => {
    // Only check when both settings and projects are loaded
    if (!settingsLoaded || !projectsLoaded) {
      return;
    }

    // Check if tenant has completed setup
    const hasCompanyName =
      settings.company_name && settings.company_name.trim() !== "";
    const hasLogo =
      settings.logo_dark_url && settings.logo_dark_url.trim() !== "";
    const hasProjects = projects.length > 0;

    const setupComplete = hasCompanyName && hasLogo && hasProjects;

    // Finish the progress bar, then swap from loading -> content just after,
    // so the 100% tick is actually visible instead of being skipped.
    setLoadProgress(100);
    const t = window.setTimeout(() => {
      setIsSetupComplete(setupComplete);
      setIsLoading(false);
    }, 300);
    return () => window.clearTimeout(t);
  }, [settingsLoaded, projectsLoaded, settings, projects]);

  // ── Reveal the header once the main view actually mounts ──────
  useEffect(() => {
    if (isLoading || !isSetupComplete) return;
    const t = window.setTimeout(() => setHeaderVisible(true), 60);
    return () => window.clearTimeout(t);
  }, [isLoading, isSetupComplete]);

  // ── Per-card scroll reveal ──────────────────────────────
  const registerCardRef = useCallback(
    (projectId) => (el) => {
      if (!el) return;
      cardRefs.current[projectId] = el;
      if (cardObserver.current) {
        cardObserver.current.observe(el);
      }
    },
    [],
  );

  useEffect(() => {
    if (!projects.length) return;

    cardObserver.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute("data-project-id");
            setVisibleCards((prev) =>
              prev[id] ? prev : { ...prev, [id]: true },
            );
            cardObserver.current.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" },
    );

    Object.values(cardRefs.current).forEach((el) => {
      if (el) cardObserver.current.observe(el);
    });

    return () => cardObserver.current && cardObserver.current.disconnect();
  }, [projects]);

  // ── Keyboard nav: amenity modal ────────────────────────
  useEffect(() => {
    if (!amenityModal) return;
    const handleKey = (e) => {
      if (e.key === "ArrowLeft") prevAmenity(null);
      if (e.key === "ArrowRight") nextAmenity(null);
      if (e.key === "Escape") closeAmenityModal();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [amenityModal]);

  // ── Keyboard nav: brochure modal ───────────────────────
  useEffect(() => {
    if (!brochureModal) return;
    const handleKey = (e) => {
      if (e.key === "Escape") closeBrochure();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [brochureModal]);

  // ── Apply theme from settings ──────────────────────────
  useEffect(() => {
    if (!settings) return;
    const root = document.documentElement;
    if (settings.primary_color)
      root.style.setProperty("--primary-color", settings.primary_color);
    if (settings.primary_color_hover)
      root.style.setProperty("--primary-hover", settings.primary_color_hover);
    if (settings.accent_color)
      root.style.setProperty("--accent-color", settings.accent_color);
    if (settings.text_color_dark)
      root.style.setProperty("--text-dark", settings.text_color_dark);
    if (settings.text_color_muted)
      root.style.setProperty("--text-muted", settings.text_color_muted);
    if (settings.card_border_color)
      root.style.setProperty("--card-border", settings.card_border_color);
    if (settings.page_bg_color)
      root.style.setProperty("--page-bg", settings.page_bg_color);
    if (settings.card_bg_color)
      root.style.setProperty("--card-bg", settings.card_bg_color);
    if (settings.heading_font)
      root.style.setProperty("--font-heading", settings.heading_font);
    if (settings.body_font)
      root.style.setProperty("--font-body", settings.body_font);
    if (settings.google_fonts_url) {
      let link = document.getElementById("dynamic-google-fonts");
      if (!link) {
        link = document.createElement("link");
        link.id = "dynamic-google-fonts";
        link.rel = "stylesheet";
        document.head.appendChild(link);
      }
      link.href = settings.google_fonts_url;
    }
  }, [settings]);

  // ── No tenant in the URL at all ─────────────────────────
  // Someone hit the bare domain instead of the link from their welcome
  // email. Checked before everything else — no point loading anything
  // if there's no tenant to load it for.
  if (!tenant) {
    return (
      <main className="projects-page projects-page--no-tenant">
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "40px 20px",
          }}
        >
          <FontAwesomeIcon
            icon={faBuilding}
            style={{ fontSize: 48, marginBottom: 24, opacity: 0.4 }}
          />
          <h1 style={{ marginBottom: 12 }}>No site selected</h1>
          <p style={{ maxWidth: 440, marginBottom: 28, color: "#6c757d" }}>
            This link doesn't point to a registered account. If you've already
            signed up, check the welcome email we sent you when you registered
            for your site's direct link. Otherwise, register to get your own
            site set up.
          </p>
          <a
            href={LANDING_URL}
            className="project-card__cta"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              alignSelf: "center",
            }}
          >
            Register / Contact us
            <FontAwesomeIcon icon={faArrowRight} className="cta-arrow" />
          </a>
        </div>
      </main>
    );
  }

  // ── Couldn't reach the server / bad tenant slug ────────
  // Distinct from "setup incomplete" — this is a real fetch failure,
  // not a tenant who simply hasn't finished onboarding yet.
  if (settingsError && projectsError) {
    const isTenantNotFound =
      settingsError.toLowerCase().includes("tenant") ||
      projectsError.toLowerCase().includes("tenant");

    return (
      <main className="projects-page">
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "40px 20px",
          }}
        >
          <FontAwesomeIcon
            icon={faBuilding}
            style={{ fontSize: 48, marginBottom: 24, opacity: 0.4 }}
          />
          <h1 style={{ marginBottom: 12 }}>We couldn't load this site</h1>
          <p style={{ maxWidth: 440, color: "#6c757d" }}>
            {isTenantNotFound
              ? "This link doesn't match a registered account. Please check the URL, or contact us if you believe this is a mistake."
              : "Something went wrong on our end. Please try again in a moment."}
          </p>
        </div>
      </main>
    );
  }

  // ── Loading overlay — sits on top of whatever screen is already
  // mounted (welcome or the main grid) and fades away once ready. Never
  // hidden while isLoading is true; also enforces a minimum display
  // window so very fast loads don't flash the overlay on then off.
  const showOverlay = isLoading || !minDisplayElapsed;

  const loadingLogoSrc = settings.logo_dark_url || null;
  const loadingMonogramLetter = (settings.company_name || "")[0] || "";

  const loadingOverlay = (
    <div
      className={`projects-loading-overlay ${!showOverlay ? "is-hidden" : ""}`}
    >
      <div className="projects-loading-card">
        {loadingLogoSrc ? (
          <img
            src={loadingLogoSrc}
            alt={settings.company_name || "Logo"}
            className="projects-loading-logo"
          />
        ) : (
          <div className="projects-loading-mark">
            {loadingMonogramLetter || (
              <FontAwesomeIcon
                icon={faBuilding}
                style={{ fontSize: 18, opacity: 0.5 }}
              />
            )}
          </div>
        )}

        <div className="projects-loading-rule">
          <div
            className="projects-loading-rule__fill"
            style={{ width: `${loadProgress}%` }}
          />
        </div>

        <div className="projects-loading-label">
          {loadProgress < 100 ? "Preparing your experience" : "Ready"}
        </div>
      </div>
    </div>
  );

  // ── Welcome / Setup Required State ────────────────────
  if (!isSetupComplete) {
    return (
      <main className="projects-page">
        <div className="projects-welcome-container">
          <div className="projects-welcome">
            <div className="welcome-logo">
              {platformSettings.app_logo_dark_url ? (
                <img
                  src={platformSettings.app_logo_dark_url}
                  alt="Platform Logo"
                  className="platform-logo"
                />
              ) : (
                <div className="platform-logo-placeholder">
                  <FontAwesomeIcon icon={faCog} size="4x" />
                </div>
              )}
            </div>

            <h1 className="welcome-title">
              Welcome to <span className="highlight">Your App</span>
            </h1>

            <p className="welcome-subtitle">
              Your tenant setup is not yet complete. Please complete the
              following steps to start showcasing your properties.
            </p>

            <div className="welcome-steps">
              <div className="welcome-step">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h3>Add Company Information</h3>
                  <p>Set up your company name, logo, and branding details</p>
                </div>
              </div>

              <div className="welcome-step">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h3>Configure Settings</h3>
                  <p>Choose colors, fonts, and design preferences</p>
                </div>
              </div>

              <div className="welcome-step">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h3>Add Your Properties</h3>
                  <p>
                    Create your first project with details, images, and
                    amenities
                  </p>
                </div>
              </div>
            </div>

            <div className="welcome-actions">
              <button
                className="welcome-cta"
                onClick={() => {
                  window.open(
                    `${ApiUrl}/${tenant}/admin/login-form`,
                    "_blank",
                    "noopener,noreferrer",
                  );
                }}
              >
                Start Setup
                <FontAwesomeIcon icon={faArrowRight} className="cta-arrow" />
              </button>
            </div>
          </div>
        </div>

        {loadingOverlay}
      </main>
    );
  }

  // ── Main Projects View (when setup is complete) ──────
  return (
    <main className="projects-page">
      {/* ── Full-screen Split Header ─────────────────────── */}
      <header
        className={`projects-header ${headerVisible ? "is-visible" : ""}`}
      >
        {/* Left: Text */}
        <div className="projects-header__left">
          {settings.logo_dark_url && (
            <div className="logo-img-div">
              <img
                src={settings.logo_dark_url}
                alt={settings.company_name || "Logo"}
                className="projects-logo"
              />
            </div>
          )}

          <div className="projects-eyebrow-wrap">
            <span className="projects-eyebrow__line" />
            <span className="projects-eyebrow">
              {settings.app_eyebrow || "Our Portfolio"}
            </span>
          </div>

          <h1 className="projects-title">
            {settings.app_tagline || "Exceptional"}
            <em>{settings.app_tagline_italic || "Properties"}</em>
          </h1>

          <p className="projects-subtitle">
            {settings.app_subtitle ||
              "Discover handcrafted developments built for modern living"}
          </p>

          <div className="projects-header__scroll">
            <span className="projects-header__scroll-line" />
            Explore below
          </div>
        </div>

        {/* Divider */}
        <div className="projects-header__divider" />

        {/* Right: Hero image — use first project's image if available */}
        {projects.length > 0 && (
          <div className="projects-header__right">
            <img
              src={projects[0].project_image_url}
              alt={projects[0].project_name}
              className="projects-header__hero-img"
            />
          </div>
        )}
      </header>

      {/* ── Section label ───────────────────────────────── */}
      <div className="projects-section-label">
        <h2 className="projects-section-label__text">
          All <em>Residences</em>
        </h2>
        {projects.length > 0 && (
          <span className="projects-section-label__count">
            {String(projects.length).padStart(2, "0")} Properties
          </span>
        )}
      </div>

      {/* ── Projects: Full-width split rows ─────────────── */}
      <div className="projects-grid">
        {projects.map((project, index) => (
          <article
            key={project.id}
            ref={registerCardRef(project.id)}
            data-project-id={project.id}
            className={`project-card ${visibleCards[project.id] ? "in-view" : ""} ${
              hoveredId === project.id ? "is-hovered" : ""
            }`}
            style={{ transitionDelay: `${Math.min(index, 4) * 90}ms` }}
            onMouseEnter={() => setHoveredId(project.id)}
            onMouseLeave={() => setHoveredId(null)}
          >
            {/* ── Image Panel ──────────────────────────── */}
            <div
              className="project-card__image-panel"
              onClick={() =>
                !project.is_upcoming &&
                navigateWithTransition(withTenant(`/location/${project.id}`))
              }
              style={{ cursor: project.is_upcoming ? "default" : "pointer" }}
            >
              <img
                src={project.project_image_url}
                alt={project.project_name}
                className="project-card__image"
              />
              <div className="project-card__image-overlay" />
              {project.is_upcoming && (
                <div className="project-card__upcoming-badge">
                  <span className="upcoming-badge__pulse" />
                  <span className="upcoming-badge__text">Coming Soon</span>
                </div>
              )}

              {/* Logo overlaid on image */}
              <div className="project-card__logo-wrap">
                <img
                  src={project.logo_url}
                  alt={`${project.project_name} logo`}
                  className="project-card__logo"
                />
              </div>
            </div>

            {/* ── Content Panel ────────────────────────── */}
            <div
              className="project-card__panel"
              data-index={String(index + 1).padStart(2, "0")}
            >
              {/* Tabs */}
              <div
                className="project-card__tabs"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  className={`tab-btn ${activeTab[project.id] === "overview" ? "active" : ""}`}
                  onClick={(e) => handleTabChange(project.id, "overview", e)}
                >
                  Overview
                </button>

                {project.amenities_count > 0 && (
                  <button
                    className={`tab-btn ${activeTab[project.id] === "amenities" ? "active" : ""}`}
                    onClick={(e) => handleTabChange(project.id, "amenities", e)}
                  >
                    <FontAwesomeIcon
                      icon={faConciergeBell}
                      className="tab-icon"
                    />
                    Amenities
                  </button>
                )}

                {project.walkthroughs?.length > 0 && (
                  <button
                    className={`tab-btn ${activeTab[project.id] === "walkthrough" ? "active" : ""}`}
                    onClick={(e) =>
                      handleTabChange(project.id, "walkthrough", e)
                    }
                  >
                    <FontAwesomeIcon icon={faWalking} className="tab-icon" />
                    Walk
                  </button>
                )}

                {project.virtual_tours?.length > 0 && (
                  <button
                    className={`tab-btn ${activeTab[project.id] === "tour" ? "active" : ""}`}
                    onClick={(e) => handleTabChange(project.id, "tour", e)}
                  >
                    <FontAwesomeIcon
                      icon={faVrCardboard}
                      className="tab-icon"
                    />
                    360°
                  </button>
                )}
              </div>

              {/* Tab Content */}
              <div className="project-card__content">
                {/* Overview */}
                {activeTab[project.id] === "overview" && (
                  <div className="tab-content">
                    <div className="project-card__location">
                      <FontAwesomeIcon
                        icon={faMapMarkerAlt}
                        className="pin-icon"
                      />
                      <span>{project.location}</span>
                    </div>

                    <h3 className="project-card__name">
                      {project.project_name}
                    </h3>

                    {project.description && (
                      <p className="project-card__description">
                        {project.description}
                      </p>
                    )}

                    <div className="project-card__actions">
                      {project.is_upcoming ? (
                        <div className="project-card__upcoming-info">
                          <span className="upcoming-info__dot" />
                          <span className="upcoming-info__text">
                            Booking opening soon
                          </span>
                        </div>
                      ) : (
                        <button
                          className="project-card__cta"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigateWithTransition(
                              withTenant(`/location/${project.id}`),
                            );
                          }}
                        >
                          Choose Your Units
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="cta-arrow"
                          />
                        </button>
                      )}
                      {!project.is_upcoming && (
                        <div className="project-card__icon-actions">
                          {/* <button
                            className="project-card__icon-btn"
                            title="Ask AI about this property"
                            onClick={(e) => {
                              e.stopPropagation();
                              aiChatRef.current?.openWithProject(project);
                            }}
                          >
                            <FontAwesomeIcon icon={faWandMagicSparkles} />
                            <span>Ask AI</span>
                          </button> */}

                          <button
                            className="project-card__icon-btn"
                            title="View Project"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigateWithTransition(
                                withTenant(`/project/${project.id}`),
                              );
                            }}
                          >
                            <FontAwesomeIcon icon={faBuilding} />
                            <span>View Project</span>
                          </button>

                          {project.master_plan_id && (
                            <button
                              className="project-card__icon-btn"
                              title="360° Panorama"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigateWithTransition(
                                  withTenant(
                                    `/apartment-view/${project.master_plan_id}`,
                                  ),
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={faVrCardboard} />
                              <span>Panorama</span>
                            </button>
                          )}

                          {project.walkthroughs?.length > 0 && (
                            <button
                              className="project-card__icon-btn"
                              title="Walkthrough"
                              onClick={(e) => {
                                e.stopPropagation();
                                window.open(
                                  project.walkthroughs[0].walkthrough_url,
                                  "_blank",
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={faWalking} />
                              <span>Walkthrough</span>
                            </button>
                          )}

                          {project.virtual_tours?.length > 0 && (
                            <button
                              className="project-card__icon-btn"
                              title="Virtual Tour"
                              onClick={(e) => {
                                e.stopPropagation();
                                window.open(
                                  project.virtual_tours[0].tour_url,
                                  "_blank",
                                );
                              }}
                            >
                              <FontAwesomeIcon icon={faVrCardboard} />
                              <span>360° Tour</span>
                            </button>
                          )}

                          {project.brochures?.length > 0 && (
                            <button
                              className="project-card__icon-btn"
                              title="Brochure"
                              onClick={(e) =>
                                openBrochure(
                                  e,
                                  project.brochures[0].brochure_url,
                                  project.brochures[0].title ||
                                    project.project_name,
                                )
                              }
                            >
                              <FontAwesomeIcon icon={faFileAlt} />
                              <span>Brochure</span>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Amenities */}
                {activeTab[project.id] === "amenities" && (
                  <div className="tab-content amenities-tab">
                    <div className="amenities-grid">
                      {project.amenities?.map((amenity, i) => (
                        <div
                          key={i}
                          className="amenity-item"
                          onClick={(e) =>
                            openAmenityModal(
                              e,
                              project.amenities,
                              project.project_name,
                              i,
                            )
                          }
                          title={amenity.amenity_name}
                        >
                          {amenity.amenity_icon ? (
                            <img
                              src={amenity.amenity_icon_url}
                              alt={amenity.amenity_name}
                              className="amenity-icon"
                            />
                          ) : (
                            <FontAwesomeIcon
                              icon={faConciergeBell}
                              className="amenity-icon-fa"
                            />
                          )}
                          <span className="amenity-name">
                            {amenity.amenity_name}
                          </span>
                          {amenity.amenity_image && (
                            <span className="amenity-expand-hint">
                              <FontAwesomeIcon icon={faExpand} />
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                    <button
                      className="project-card__cta mt-3"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigateWithTransition(
                          withTenant(`/location/${project.id}`),
                        );
                      }}
                    >
                      Explore Project
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="cta-arrow"
                      />
                    </button>
                  </div>
                )}

                {/* Walkthrough */}
                {activeTab[project.id] === "walkthrough" && (
                  <div className="tab-content tour-tab">
                    <h4 className="tab-heading">Walkthrough</h4>
                    {project.walkthroughs.map((wt, i) => (
                      <div
                        key={i}
                        className="tour-preview"
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(wt.walkthrough_url, "_blank");
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faWalking}
                          className="tour-play-icon"
                        />
                        <span>{wt.title || `Walkthrough ${i + 1}`}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* 360° Tour */}
                {activeTab[project.id] === "tour" && (
                  <div className="tab-content tour-tab">
                    <h4 className="tab-heading">360° Virtual Tour</h4>
                    {project.virtual_tours.map((vt, i) => (
                      <div
                        key={i}
                        className="tour-preview"
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(vt.tour_url, "_blank");
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faVrCardboard}
                          className="tour-play-icon"
                        />
                        <span>{vt.title || `360° Tour ${i + 1}`}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </article>
        ))}
      </div>

      {/* ── Amenity Modal ───────────────────────────────── */}
      {amenityModal && (
        <div className="amenity-modal-overlay" onClick={closeAmenityModal}>
          <div className="amenity-modal" onClick={(e) => e.stopPropagation()}>
            <div className="amenity-modal__header">
              <h5>{amenityModal.projectName} — Amenities</h5>
              <button className="modal-close-btn" onClick={closeAmenityModal}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            <div className="amenity-modal__stage">
              {amenityModal.amenities.length > 1 && (
                <button
                  className="amenity-modal__nav amenity-modal__nav--prev"
                  onClick={prevAmenity}
                >
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    style={{ transform: "rotate(180deg)" }}
                  />
                </button>
              )}

              <div className="amenity-modal__image-wrap">
                {amenityModal.amenities[amenityModal.currentIndex]
                  ?.amenity_image ? (
                  <img
                    key={amenityModal.currentIndex}
                    src={
                      amenityModal.amenities[amenityModal.currentIndex]
                        .amenity_image_url
                    }
                    alt={
                      amenityModal.amenities[amenityModal.currentIndex]
                        .amenity_name
                    }
                    className="amenity-modal__image"
                  />
                ) : (
                  <div className="amenity-modal__no-image">
                    <FontAwesomeIcon icon={faConciergeBell} />
                    <span>No image available</span>
                  </div>
                )}

                <div className="amenity-modal__name-overlay">
                  {amenityModal.amenities[amenityModal.currentIndex]
                    ?.amenity_icon && (
                    <img
                      src={
                        amenityModal.amenities[amenityModal.currentIndex]
                          .amenity_icon_url
                      }
                      alt="icon"
                      className="amenity-modal__icon-badge"
                    />
                  )}
                  <span className="amenity-modal__name">
                    {
                      amenityModal.amenities[amenityModal.currentIndex]
                        ?.amenity_name
                    }
                  </span>
                  <span className="amenity-modal__counter">
                    {amenityModal.currentIndex + 1} /{" "}
                    {amenityModal.amenities.length}
                  </span>
                </div>
              </div>

              {amenityModal.amenities.length > 1 && (
                <button
                  className="amenity-modal__nav amenity-modal__nav--next"
                  onClick={nextAmenity}
                >
                  <FontAwesomeIcon icon={faArrowRight} />
                </button>
              )}
            </div>

            {amenityModal.amenities.length > 1 && (
              <div className="amenity-modal__thumbs">
                {amenityModal.amenities.map((amenity, i) => (
                  <div
                    key={i}
                    className={`amenity-thumb ${i === amenityModal.currentIndex ? "active" : ""}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setAmenityModal((prev) => ({
                        ...prev,
                        currentIndex: i,
                      }));
                    }}
                  >
                    {amenity.amenity_icon ? (
                      <img
                        src={amenity.amenity_icon_url}
                        alt={amenity.amenity_name}
                        className="amenity-thumb__icon"
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faConciergeBell}
                        className="amenity-thumb__fa"
                      />
                    )}
                    <span className="amenity-thumb__name">
                      {amenity.amenity_name}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── Brochure Modal ──────────────────────────────── */}
      {brochureModal && (
        <div className="brochure-modal-overlay" onClick={closeBrochure}>
          <div className="brochure-modal" onClick={(e) => e.stopPropagation()}>
            <div className="brochure-modal__header">
              <h5>{brochureModal.name}</h5>
              <button className="modal-close-btn" onClick={closeBrochure}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="brochure-modal__body">
              <iframe
                src={brochureModal.url}
                title="Brochure"
                width="100%"
                height="100%"
                style={{ border: "none" }}
              />
            </div>
            <div className="brochure-modal__footer">
              <a
                href={brochureModal.url}
                download
                className="project-card__cta"
                onClick={(e) => e.stopPropagation()}
              >
                <FontAwesomeIcon icon={faFileAlt} />
                Download PDF
              </a>
            </div>
          </div>
        </div>
      )}

      {/* ── Page-transition overlay ──────────────────────
          Fades in before navigateWithTransition swaps the route
          underneath it, so the change reads as one motion. */}
      <div
        className={`page-transition-overlay ${isTransitioning ? "is-active" : ""}`}
        aria-hidden="true"
      />

      {loadingOverlay}

      {/* ── AI chat widget ───────────────────────────────
          Floating trigger for general questions; card "Ask AI" buttons
          open it pre-scoped to that project via aiChatRef. */}
      {/* <AIChatWidget
        tenant={tenant}
        projects={projects}
        onReady={(api) => {
          aiChatRef.current = api;
        }}
      /> */}
    </main>
  );
};

export default ProjectsLayout;
